import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import configParam from "../config";
import { ReactComponent as LineArea } from './../Asset/Icons/LineArea.svg';
import { ReactComponent as DocumentIcon } from './../Asset/Icons/DocumentIcon.svg';
import { ReactComponent as DocumentIcon1 } from './../Asset/Icons/DocumentIcon1.svg';
import {
  Card,
  Typography,
  Avatar,
  Tooltip,
  CardContent,
  Button,
  Box,
  Grid,
  Divider,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AccordionItem,
  AccordionPanel,
  AccordionHeader,
  Select,
  MenuItem,
  IconButton,
  Menu,
  Checkbox,
  FormControl
  , InputLabel
} from "@mui/material";
import GoldBadge from "../Asset/Icons/gold_badge.svg";
import silverBadge from "../Asset/Icons/badge_silver.svg";
import fivesBanner from "../Asset/Icons/fivesBanner.jpg";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Bar } from "react-chartjs-2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ListItemText
} from "@mui/material";
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
} from "chart.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import annotationPlugin from "chartjs-plugin-annotation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleUp,
  faArrowCircleDown,
} from "@fortawesome/free-solid-svg-icons";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Radar } from "react-chartjs-2";
import FileSaver from "file-saver";
import * as htmlToImage from "html-to-image";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GetAppIcon from "@mui/icons-material/GetApp";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ApexCharts from "react-apexcharts"; // Rename ApexCharts import to avoid conflict
import PieChartComponentCoordinator from "../Inputs/PieChartComponentCoordinator";
import PieChartComponentGroupLeader from "../Inputs/PieChartComponentGroupLeader";
import DashboardLayout from "./Dashboard/DashboardLayout";
import AuditFilter from "../Inputs/AuditFilter";
import AccordionTable from "./Dashboard/AccordionTable";
import BarChartDashboard from "./Dashboard/BarChartDashboard";

Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  annotationPlugin
);

const Dashboard = () => {
  const ApiURL = configParam.API_URL;
  const access_token = JSON.parse(localStorage.getItem("accesstoken"));
  const [userRole, setUserRole] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [groupLeaderChartData, setGroupLeaderChartData] = useState([]);
  const [groupLeaderChartDataPie, setGroupLeaderChartDataPie] = useState([]);
  const [coordinatorChartData, setCoordinatorChartData] = useState([]);
  const [coordinatorChartDataPie, setCoordinatorChartDataPie] = useState([]);
  const [coordinatorFirstChData, setCoordinatorFirstChData] = useState([]);
  const [expandedZones, setExpandedZones] = useState({});
  const [zones, setZones] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [zoneanchorEl, setZoneAnchorEl] = useState(null);
  const [latestMassFive, setLatestMassFive] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState(null); // Initially no group selected
  const [availableGroups, setAvailableGroups] = useState([]);
  const iszoneleader = userRole.some((user) => user.zone_first_name);
  // const isgroupleader = userRole.some(user => user.group_firstname);
  const groupLeaderRole = userRole.find(
    (user) => user.groupname && user.zone_group_id
  );
  const isGroupLeader = Boolean(groupLeaderRole);
  const canAccessDashboard = userRole.some(
    (role) => role.is_zone_member === "Yes" || role.zone_first_name
  );
  const isCoordinatorRole = userRole.some(
    (user) => user.wcm_coordinatorname && user.zone_group_id
  );
  const isCoordinator = Boolean(isCoordinatorRole);
  const isWcmheadRole = userRole.some(
    (user) => user.wcm_headlastname && user.zone_group_id
  );
  const isWcmhead = Boolean(isWcmheadRole);

   const isPlantheadRole = userRole.some(
    (user) => user.plant_headlastname && user.zone_group_id
  );
  const isPlanthead = Boolean(isPlantheadRole);
  console.log("isPlanthead",isPlanthead)
  const [selectedYearFirstgraph, setSelectedYearFirstGraph] = useState(new Date().getFullYear());
  const [selectedGroupFirstgraph, setSelectedGroupFirstgraph] = useState("all");
  // const [selectedZoneFirstgraph, setSelectedZoneFirstgraph] = useState("all")
  const [selectedZoneFirstgraph, setSelectedZoneFirstgraph] = useState([]);
  const [availableGroupsFirstGraph, setAvailableGroupsFirstGraph] = useState([]);
  const [availableZonesFirstGraph, setAvailableZonesFirstGraph] = useState([]);
  const [uniqueZoneGroupIds, setUniqueZoneGroupIds] = useState([]);
  const [selectAllZones, setSelectAllZones] = useState(false);
  const [selectedYearSecondgraph, setSelectedYearSecondGraph] = useState(new Date().getFullYear());

  const [selectedGroupSecondgraph, setSelectedGroupSecondgraph] = useState([]); // Initially select "all"
  const [selectedZoneSecondgraph, setSelectedZoneSecondgraph] = useState([]);
  const [availableGroupsSecondGraph, setAvailableGroupsSecondGraph] = useState([]);
  const [availableZonesSecondGraph, setAvailableZonesSecondGraph] = useState([]);
  const [uniqueSecondZoneGroupIds, setUniqueSecondZoneGroupIds] = useState([]);
  const [selectSecondAllZones, setSelectSecondAllZones] = useState(false);
  const [coordinatorSecondChData, setCoordinatorSecondChData] = useState([]);
  const [chartanchorEl, setChartAnchorEl] = useState(null);
  const open = Boolean(chartanchorEl);
  const [chartFirstAnchorEl, setChartFirstAnchorEl] = useState(null);
  const openFirst = Boolean(chartFirstAnchorEl);

  const [chartSecondAnchorEl, setChartSecondAnchorEl] = useState(null);
  const openSecond = Boolean(chartSecondAnchorEl);
  const [groupCount, setGroupCount] = useState(0);
  const [zoneCount, setZoneCount] = useState(0);
  const [completedAuditsCount, setCompletedAuditsCount] = useState(0);

  const [monthsAndYears, setMonthsAndYears] = useState([]);
  const [selectedMonthElite, setSelectedMonthElite] = useState('');
  const [selectedYearElite, setSelectedYearElite] = useState('');
  const [Elitedata, setEliteData] = useState([]);
  const [averageOfTotalPositiveScores, setAverageOfTotalPositiveScores] = useState(0);
  const [zoneInfo, setZoneInfo] = useState("");
  const [groupNameInfo, setGroupNameInfo] = useState("");
  const [selectedYearPieCoord, setSelectedYearPieCoord] = useState(new Date().getFullYear());
  const [selectedMonthPieCoord, setSelectedMonthPieCoord] = useState(new Date().getMonth() + 1);
  const [selectedYearPieGroup, setSelectedYearPieGroup] = useState(new Date().getFullYear());
  const [selectedMonthPieGroup, setSelectedMonthPieGroup] = useState(new Date().getMonth() + 1);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const currentMonthIndex = new Date().getMonth();
  const previousMonthIndex =
    currentMonthIndex === 0 ? 11 : currentMonthIndex - 1;
  const [selectedStartMonth, setSelectedStartMonth] = useState(
    months[currentMonthIndex]
  );
  const [selectedEndMonth, setSelectedEndMonth] = useState(
    months[previousMonthIndex]
  );
  const [coordinatorRadarData, setCoordinatorRadarData] = useState([]);
  const [selectedMonthsRadar, setSelectedMonthsRadar] = useState([new Date().getMonth() + 1]);
  const [selectedYearRadar, setSelectedYearRadar] = useState(new Date().getFullYear());
  const [groupRadarData, setGroupRadarData] = useState([]);
  const [selectedMonthsGroupRadar, setSelectedMonthsGroupRadar] = useState([new Date().getMonth() + 1]);
  const [selectedYearGroupRadar, setSelectedYearGroupRadar] = useState(new Date().getFullYear());
  // console.log("iszoneleader", iszoneleader)
  console.log("userRole123", userRole)
  const styles = {
    card: {
      position: "relative",
      display: "flex",
      marginBottom: "16px",
      border: "1px solid #ddd",
      padding: "8px",
      borderRadius: "8px",
      alignItems: "center",
      marginTop: "8px",
      justifyContent: "space-between",
      flexDirection: "row",
    },
  };
  useEffect(() => {
    getRole();
  }, []);

  const getRole = () => {
    setLoading(true);
    const userDatas = JSON.parse(localStorage.getItem("userDatas"));
    const userid = userDatas.id;
    const plantId = localStorage.getItem("selectedPlantId");
    axios
      .get(`${ApiURL}/getroleuserdashboard/${userid}/${plantId}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          if (response.data && response.data.length > 0) {
            setUserRole(response.data);
            // console.log("userRole", response.data);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching assessment data:", error);
      });
  };
  const userDatas = JSON.parse(localStorage.getItem("userDatas"));
  const firstName = userDatas.firstName;
  const lastName = userDatas.lastName;
  const fetchYears = async () => {
    try {
      const selectedPlantId = localStorage.getItem("selectedPlantId");
      const response = await axios.get(`${ApiURL}/get_available_years`, {
        headers: { Authorization: `Bearer ${access_token}` },
        params: { selectedPlantId },
      });
      setYears(response.data);
    } catch (error) {
      console.error("Error fetching months and years:", error);
    }
  };
  useEffect(() => {
    fetchYears();
  }, []);

  useEffect(() => {
    if (isGroupLeader || isCoordinator || isWcmhead ||isPlanthead) {
      fetchLatestMassFive();
    }
  }, [isGroupLeader, isCoordinator,isWcmhead,isPlanthead]);
  const fetchLatestMassFive = async () => {
    try {
      const selectedPlantId = localStorage.getItem("selectedPlantId");
      const response = await axios.get(`${ApiURL}/get_latest_mass_five`, {
        params: { plantId: selectedPlantId },
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      // console.log(response.data || [], "response.data || []");
      setLatestMassFive(response.data || []);
    } catch (error) {
      console.error("Error fetching latest mass five:", error);
    }
  };

 
  useEffect(() => {
    if (canAccessDashboard) {
      const zoneRole = userRole.find(
        (role) => role.is_zone_member === "Yes" || role.zone_first_name
      );
      if (zoneRole) {
        setSelectedZoneId(zoneRole.zone_id);
      }
    }
  }, [userRole, canAccessDashboard]);
  useEffect(() => {
    if (isGroupLeader) {
      fetchZones();
    }
  }, [isGroupLeader]);
  useEffect(() => {
    if (selectedZoneId || selectedYear) {
      if (isGroupLeader) {
        fetchGroupLeaderData(
          groupLeaderRole.zone_group_id,
          selectedYear,
          selectedZoneId
        );
      } else {
        fetchData();
      }
    }
  }, [selectedZoneId, selectedYear, isGroupLeader]);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    if (isGroupLeader) {
      fetchGroupLeaderData(groupLeaderRole.zone_group_id, event.target.value);
    }
    // } else {
    //     fetchData();
    // }
  };
  const handleZoneChange = (event) => {
    setSelectedZoneId(event.target.value);
    if (isGroupLeader) {
      fetchGroupLeaderData(
        groupLeaderRole.zone_group_id,
        selectedYear,
        event.target.value
      );
    } else {
      fetchData();
    }
  };
  const fetchData = async () => {
    setLoading(true);
    if (selectedZoneId && !isGroupLeader) {
      try {
        const selectedPlantId = localStorage.getItem("selectedPlantId");
        const response = await axios.get(`${ApiURL}/get_dashoard_details`, {
          params: {
            zoneId: selectedZoneId,
            plantId: selectedPlantId,
            year: selectedYear,
          },
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
        setLoading(false);
        const firstItem = response.data?.[0];
        if (firstItem) {
          setZoneInfo(`${firstItem.zone_name} (Code: ${firstItem.zone_code})`);
        }

        const filteredData = (response.data || []).filter(
          (item) => item.status_flg === "C"
        );
        setChartData(filteredData);
        // console.log("selectedZoneId", selectedZoneId)
        // setChartData(response.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const fetchZones = async () => {
    try {
      const selectedPlantId = localStorage.getItem("selectedPlantId");
      const groupId = userRole.find(
        (user) => user.groupname && user.zone_group_id
      )?.zone_group_id;
      if (!groupId) return;

      const response = await axios.get(`${ApiURL}/get_zones_by_group`, {
        params: { group_id: groupId, selectedPlantId },
        headers: { Authorization: `Bearer ${access_token}` },
      });

      setZones(response.data || []);
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };

  const fetchGroupLeaderData = async (zoneGroupId, year) => {
    setLoading(true);
    try {
      const selectedPlantId = localStorage.getItem("selectedPlantId");
      // const userDatas = JSON.parse(localStorage.getItem("userDatas"));
      // const userId = userDatas.id;

      // Send request to backend with plantId and specific zoneGroupId
      const response = await axios.get(`${ApiURL}/get_dashoard_details_group`, {
        params: {
          plantId: selectedPlantId,
          zoneGroupId: zoneGroupId || null,
          selectedYear: year || null,
          selectedZoneId: selectedZoneId || null,
        }, // Pass zoneGroupId
        headers: { Authorization: `Bearer ${access_token}` },
      });

      setLoading(false);

      // Filter for assessments with status_flg === 'C'
      // setGroupLeaderChartData(response.data || []);
      const completedAssessments = response.data.filter(
        (assessment) => assessment.status_flag === "C"
      );

      setGroupLeaderChartData(completedAssessments);
      if (response.data.length > 0) {
        setGroupNameInfo(response.data[0].group_name || "");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching group leader data:", error);
    }
  };

  const handleYearChangePieChartGroup = (event) => {
    setSelectedYearPieGroup(event.target.value);
   
  };

  const handleMonthChangePieChartGroup = (event) => {
    setSelectedMonthPieGroup(event.target.value);
  
  };
  const fetchGroupLeaderPieChartData = async (zoneGroupId, year, month) => {
    setLoading(true);
    try {
      const selectedPlantId = localStorage.getItem("selectedPlantId");
      const response = await axios.get(`${ApiURL}/get_dashoard_piechart_group`, {
        params: {
          plantId: selectedPlantId,
          zoneGroupId: zoneGroupId || null,
          selectedYear: year || null,
          selectedMonth: month || null,
          selectedZoneId: selectedZoneId || null,
        },
        headers: { Authorization: `Bearer ${access_token}` },
      });

      setLoading(false);
      const completedAssessments = response.data.filter(
        (assessment) => assessment.status_flag === "C"
      );

      setGroupLeaderChartDataPie(completedAssessments);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching group leader data:", error);
    }
  };
  useEffect(() => {
    if (isGroupLeader) {
      fetchGroupLeaderPieChartData(groupLeaderRole.zone_group_id, selectedYearPieGroup, selectedMonthPieGroup);
    }
  }, [selectedYearPieGroup, selectedMonthPieGroup,isGroupLeader]);

  //radar chart Groupleader

 
  useEffect(() => {
    if (isGroupLeader) {
        fetchGroupLeaderDataRadarchart(groupLeaderRole.zone_group_id, selectedYearGroupRadar, selectedMonthsGroupRadar);
    }
}, [selectedYearGroupRadar, selectedMonthsGroupRadar, isGroupLeader]);
 
  const fetchGroupLeaderDataRadarchart = async (zoneGroupId, year, months) => {
    setLoading(true);
    try {
        const selectedPlantId = localStorage.getItem("selectedPlantId");
        const response = await axios.get(`${ApiURL}/get_dashoard_radar_group`, {
            params: {
                plantId: selectedPlantId,
                zoneGroupId: zoneGroupId || null,
                selectedYear: year || null,
                selectedMonths: months || null,
            },
            headers: { Authorization: `Bearer ${access_token}` },
        });

        setLoading(false);
        const completedAssessments = response.data.filter(
            (assessment) => assessment.status_flag === "C"
        );

        setGroupRadarData(completedAssessments);
    } catch (error) {
        setLoading(false);
        console.error("Error fetching group leader data:", error);
    }
};

  const monthMap = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };

  const handleStartMonthChange = (event) => {
    const selectedMonthName = event.target.value; // e.g., "Jun"
    const selectedYear = "2024"; // Adjust this to your specific year selection logic
    const formattedStartMonth = `${selectedYear}-${monthMap[selectedMonthName]}`;
    setSelectedStartMonth(formattedStartMonth);
  };

  const handleEndMonthChange = (event) => {
    const selectedMonthName = event.target.value; // e.g., "Nov"
    const selectedYear = "2024"; // Adjust this to your specific year selection logic
    const formattedEndMonth = `${selectedYear}-${monthMap[selectedMonthName]}`;
    setSelectedEndMonth(formattedEndMonth);
  };

  const filteredDatagroupdata = groupLeaderChartData.filter((item) => {
    const itemMonthYear = `${item.audit_year}-${item.audit_month.padStart(
      2,
      "0"
    )}`;
    return (
      itemMonthYear >= selectedStartMonth && itemMonthYear <= selectedEndMonth
    );
  });

  // console.log("filteredDatagroupdata", filteredDatagroupdata);

  //corrected code

  useEffect(() => {
    if (isCoordinator || isWcmhead||isPlanthead) {
      // Filter entries that have both zone_group_id and wcm_coordinatorname
      // const filteredData = userRole.filter(
      //   (entry) => entry.zone_group_id && entry.wcm_coordinatorname
      // );
      const filteredData = userRole.filter(
        (entry) =>
          entry.zone_group_id &&
          (entry.wcm_coordinatorname || entry.wcm_headlastname||
         entry.plant_headlastname)
      );
      const uniqueGroupsMap = new Map();
      filteredData.forEach((entry) => {
        if (!uniqueGroupsMap.has(entry.zone_group_id)) {
          uniqueGroupsMap.set(entry.zone_group_id, {
            group_id: entry.zone_group_id,
            group_name: entry.group_name,
          });
        }
      });

      // Convert the Map values to an array for availableGroups
      const groupIds = Array.from(uniqueGroupsMap.keys());
      setAvailableGroups(Array.from(uniqueGroupsMap.values()));
      setGroupCount(uniqueGroupsMap.size);
      fetchZonesByGroupIds(groupIds);

      fetchCoordinatorData(
        new Date().getFullYear(),
        Array.from(uniqueGroupsMap.keys())
      );
    }
  }, [isCoordinator,isWcmhead,isPlanthead]);


  const fetchZonesByGroupIds = async (groupIds) => {
    try {
      const selectedPlantId = localStorage.getItem("selectedPlantId");
      if (!selectedPlantId) {
        console.error("Selected Plant ID not found.");
        return;
      }

      const response = await axios.post(
        `${ApiURL}/zone_count_coordinator`,
        {
          groupIds, // Send groupIds array in the body
          selectedPlantId,
        },
        {
          headers: { Authorization: `Bearer ${access_token}` },
        }
      );

      const zones = response.data; // Response is already parsed
      // console.log("Zones:", zones);

      if (Array.isArray(zones)) {
        setZoneCount(zones.length); // Set the count of zones
      } else {
        console.error("Invalid zones response format.");
      }
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };



  useEffect(() => {
    if (isCoordinator || isWcmhead || isPlanthead) {
      fetchCoordinatorData()
    }
  }, []);
  const fetchCoordinatorData = async (
    year = selectedYear,
    groups = selectedGroup === "all"
      ? availableGroups.map((group) => group.group_id)
      : [selectedGroup]
  ) => {
    setLoading(true);
    try {
      const selectedPlantId = localStorage.getItem("selectedPlantId");
      // const groupFilter = selectedGroup ? [selectedGroup] : groupIds;
      const response = await axios.get(`${ApiURL}/get_dashboard_coordinator`, {
        params: {
          plantId: selectedPlantId,
          year: selectedYear,
          // year,
          zoneGroupIds: groups,
          // zoneGroupIds: groupIds // Pass the unique zoneGroupIds array
        },
        headers: { Authorization: `Bearer ${access_token}` },
      });

      const completedAssessments = response.data.filter(
        (assessment) => assessment.status_flag === "C"
      );

      // console.log("completedAssessments", completedAssessments);s

      setCoordinatorChartData(completedAssessments);
      // setCoordinatorChartDataPie(completedAssessments)
      // setCoordinatorRadarData(completedAssessments)
      setCompletedAuditsCount(getCompletedAuditsCountCoordinator(completedAssessments));
      setAverageOfTotalPositiveScores(getAverageOfAveragePositiveScores(completedAssessments));
      const overallAveragePositiveScore = getAverageOfAveragePositiveScores(completedAssessments);
      console.log("Overall Average Positive Score:", overallAveragePositiveScore);
      // setCoordinatorChartData(response.data); // Set the data received from the API
      setLoading(false); // End loading state
    } catch (error) {
      console.error("Error fetching coordinator data:", error);
      setLoading(false); // End loading state on error
    }
  };


  //old code
  const getAverageOfAveragePositiveScores = (data) => {
    if (data.length === 0) return 0;

    // Get unique groups and calculate the average positive scores per group
    const uniqueGroups = [...new Set(data.map(item => item.group_name))];

    // For each unique group, calculate its average positive score
    const groupAverages = uniqueGroups.map(groupName => {
      const groupData = data.filter(item => item.group_name === groupName);
      const totalPositiveScore = groupData.reduce((sum, item) => {
        const { positiveScores } = calculateScores(item.details); // Get individual positive scores
        return sum + positiveScores;
      }, 0);

      return totalPositiveScore / groupData.length; // Average positive score for this group
    });
    console.log("groupAveragesgroupAverages", groupAverages)

    // Calculate the overall average of these group averages
    const overallAverage = groupAverages.reduce((sum, avg) => sum + avg, 0) / groupAverages.length;
    return overallAverage.toFixed(1); // Round to 1 decimal places for display
  };



  // const getGroupCounts = (data) => {
  //   const uniqueGroups = new Set(data.map((item) => item.ass_group_id));
  //   return uniqueGroups.size; // Return the count of unique ass_group_id
  // };
  const getGroupCounts = (data) => {
    const uniqueGroups = new Set(data.map((item) => item.zone_group_id));
    return uniqueGroups.size; // Return the count of unique zone_group_id
  };
  // Function to get the unique count of zone_id
  // const getTotalZoneCounts = (data) => {
  //   const uniqueZones = new Set(data.map((item) => item.zone_id));
  //   return uniqueZones.size;
  // };

  const getTotalPlants = () => {
    return 1; // Always returns 1 since there's only one plant
  };


  const getTotalCoordinatorCount = () => {
    return 12 * zoneCount; // Calculate total coordinator count
  };
  // const getTotalCoordinatorCount = (data) => {
  //   console.log("dataconsole",data)
  //   const uniqueZones = new Set(data.map((item) => item.zone_id));
  //   const uniqueZoneCount = uniqueZones.size; // Get the unique zone count
  //   return uniqueZoneCount * 12; // Return the total score
  // };
  const getCompletedAuditsCountCoordinator = (data) => {
    return data.length; // Return the count of completed assessments
  };
  const getPendingAuditsCountCoordinator = (data) => {
    const totalScore = getTotalCoordinatorCount(data); // Calculate total score
    const completedCount = getCompletedAuditsCountCoordinator(data); // Get completed audits count
    return totalScore - completedCount; // Calculate and return the pending count
  };

  useEffect(() => {
    if (isCoordinator || isWcmhead||  isPlanthead) {
      // const filteredData = userRole.filter(entry => entry.zone_group_id && entry.wcm_coordinatorname);
      const filteredData = userRole.filter(
        (entry) =>
          entry.zone_group_id &&
          (entry.wcm_coordinatorname || entry.wcm_headlastname || entry.plant_headlastname)
      );
      const uniqueGroupsMap = new Map();

      filteredData.forEach(entry => {
        if (!uniqueGroupsMap.has(entry.zone_group_id)) {
          uniqueGroupsMap.set(entry.zone_group_id, {
            group_id: entry.zone_group_id,
            group_name: entry.group_name
          });
        }
      });
      const uniqueGroupIds = Array.from(uniqueGroupsMap.keys());
      setUniqueZoneGroupIds(uniqueGroupIds);

      setAvailableGroupsFirstGraph(Array.from(uniqueGroupsMap.values()));
      fetchCoordinatorDataOne(selectedYearFirstgraph, uniqueGroupIds, "all");
      
    }
  }, [isCoordinator,isWcmhead,isPlanthead]);



  const fetchZonesForGroup = async () => {
    if (selectedGroupFirstgraph === "all") {
      setAvailableZonesFirstGraph([]);
      setSelectAllZones(false);
      return;
    }
    try {
      const selectedPlantId = localStorage.getItem('selectedPlantId');
      const response = await axios.get(`${ApiURL}/get_zones_for_avaigroup`, {
        params: { groupId: selectedGroupFirstgraph, selectedPlantId },
        headers: { Authorization: `Bearer ${access_token}` }
      });
      setAvailableZonesFirstGraph(response.data);
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };

  useEffect(() => {
    fetchZonesForGroup();
  }, [selectedGroupFirstgraph]);
//old working code
  // useEffect(() => {
  //   fetchCoordinatorDataOne(selectedYearFirstgraph, uniqueZoneGroupIds, selectedZoneFirstgraph);
  // }, [selectedYearFirstgraph, uniqueZoneGroupIds, selectedZoneFirstgraph]);
  useEffect(() => {
    let groupIds = selectedGroupFirstgraph === "all" ? uniqueZoneGroupIds : [selectedGroupFirstgraph];
    fetchCoordinatorDataOne(selectedYearFirstgraph, groupIds, selectedZoneFirstgraph);
  }, [selectedYearFirstgraph, selectedGroupFirstgraph, selectedZoneFirstgraph]);
  
  // Fetch data based on selected filters
  //old working code
  // const fetchCoordinatorDataOne = async (year, zoneGroupIds, zoneIds) => {
  //   try {
  //     const selectedPlantId = localStorage.getItem('selectedPlantId');
  //     const groups = zoneGroupIds.length === 0 ? [] : zoneGroupIds;
  //     const zones = zoneIds.length === 0 || zoneIds[0] === "all" ? [] : zoneIds;
     
  //     const response = await axios.get(`${ApiURL}/get_dashboard_coordinator_graph`, {
  //       params: { plantId: selectedPlantId, year, zoneGroupIds: groups, zoneIds: zones },
  //       headers: { Authorization: `Bearer ${access_token}` },
  //     });

  //     const completedAssessments = response.data.filter(assessment => assessment.status_flag === 'C');
  //     console.log("completedAssessments", completedAssessments)
  //     setCoordinatorFirstChData(completedAssessments);
  //   } catch (error) {
  //     console.error("Error fetching coordinator data:", error);
  //   }
  // };
  const fetchCoordinatorDataOne = async (year, zoneGroupIds, zoneIds = "all") => {
    try {
        const selectedPlantId = localStorage.getItem('selectedPlantId');
        
        const groups = zoneGroupIds.length === 0 || zoneGroupIds[0] === "all" 
            ? uniqueZoneGroupIds 
            : zoneGroupIds;
        const zones = (!zoneIds || zoneIds.length === 0 || zoneIds === "all") 
            ? [] 
            : zoneIds;

        const response = await axios.get(`${ApiURL}/get_dashboard_coordinator_graph`, {
            params: { plantId: selectedPlantId, year, zoneGroupIds: groups, zoneIds: zones },
            headers: { Authorization: `Bearer ${access_token}` },
        });

        const completedAssessments = response.data.filter(assessment => assessment.status_flag === 'C');
        // console.log("completedAssessments", completedAssessments);
        setCoordinatorFirstChData(completedAssessments);
    } catch (error) {
        console.error("Error fetching coordinator data:", error);
    }
};


  useEffect(() => {
    if (isCoordinator || isWcmhead ||isPlanthead) {
      // const filteredData = userRole.filter(entry => entry.zone_group_id && entry.wcm_coordinatorname);
      const filteredData = userRole.filter(
        (entry) =>
          entry.zone_group_id &&
          (entry.wcm_coordinatorname || entry.wcm_headlastname|| entry.plant_headlastname)
      );
      const uniqueGroupsMap = new Map();

      filteredData.forEach(entry => {
        if (!uniqueGroupsMap.has(entry.zone_group_id)) {
          uniqueGroupsMap.set(entry.zone_group_id, {
            group_id: entry.zone_group_id,
            group_name: entry.group_name
          });
        }
      });
      const uniqueGroupIds = Array.from(uniqueGroupsMap.keys());
      setUniqueSecondZoneGroupIds(uniqueGroupIds);

      setAvailableGroupsSecondGraph(Array.from(uniqueGroupsMap.values()));
      fetchCoordinatorDataTwo(selectedYearSecondgraph, uniqueGroupIds, []);
      // fetchCoordinatorDataOne(selectedYearFirstgraph, "all", "all");
    }
  }, [isCoordinator,isWcmhead,isPlanthead]);

  useEffect(() => {
    fetchCoordinatorDataTwo(selectedYearSecondgraph, selectedGroupSecondgraph, selectedZoneSecondgraph);
  }, [selectedYearSecondgraph, selectedGroupSecondgraph, selectedZoneSecondgraph]);
  useEffect(() => {
    // Fetch data when "All Group" is selected initially
    if (selectedGroupSecondgraph.includes("all")) {
      fetchCoordinatorDataTwo(selectedYearSecondgraph, ["all"], []);
    }
  }, []);

  useEffect(() => {


    fetchZonesForGroupTwo();
  }, [selectedGroupSecondgraph]);
  const fetchZonesForGroupTwo = async () => {
    if (selectedGroupSecondgraph.length === 0 || selectedGroupSecondgraph.includes("all")) {
      setAvailableZonesSecondGraph([]);
      setSelectSecondAllZones(false);
      return;
    }
    try {
      const selectedPlantId = localStorage.getItem('selectedPlantId');
      const response = await axios.get(`${ApiURL}/get_zones_for_avaigroup_sec`, {
        params: { groupId: selectedGroupSecondgraph, selectedPlantId },
        headers: { Authorization: `Bearer ${access_token}` }
      });
      setAvailableZonesSecondGraph(response.data);
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };

  const fetchCoordinatorDataTwo = async (year, zoneGroupIds, zoneIds) => {
    try {
      const selectedPlantId = localStorage.getItem('selectedPlantId');
      const groups = zoneGroupIds.length === 0 || zoneGroupIds.includes("all") ? [] : zoneGroupIds;
      const zones = zoneIds.length === 0 || zoneIds === "all" ? [] : zoneIds;

      const response = await axios.get(`${ApiURL}/get_dashboard_coord_sec_graph`, {
        params: { plantId: selectedPlantId, year, zoneGroupIds: groups, zoneIds: zones },
        headers: { Authorization: `Bearer ${access_token}` },
      });

      // Filter completed assessments to include only those with valid group IDs
      const completedAssessments = response.data.filter((assessment) => {
        const isCompleted = assessment.status_flag === 'C';
        const hasValidGroup = assessment.ass_group_id !== null;
        return isCompleted && hasValidGroup;
      });

      setCoordinatorSecondChData(completedAssessments);
    } catch (error) {
      console.error("Error fetching coordinator data:", error);
    }
  };





  const generateChartDataSecondgraph = () => {
    const monthlyScores = Array(12).fill(0).map(() => ({ totalScore: 0, count: 0 }));
    const groupScores = {};
    const groupNames = {};
    const colorPalette = [
      'rgba(255, 99, 132, 0.6)',
      'rgba(54, 162, 235, 0.6)',
      'rgba(255, 206, 86, 0.6)',
      'rgba(75, 192, 192, 0.6)',
      'rgba(153, 102, 255, 0.6)',
      'rgba(255, 159, 64, 0.6)'
    ];

    coordinatorSecondChData.forEach((assessment) => {
      const monthIndex = parseInt(assessment.audit_month) - 1;
      const groupId = assessment.ass_group_id;
      const groupName = assessment.group_name;

      // Store the group name in the groupNames object
      groupNames[groupId] = groupName;
      if (!groupScores[groupId]) {
        groupScores[groupId] = Array(12).fill(0).map(() => ({ totalScore: 0, count: 0 }));
      }

      groupScores[groupId][monthIndex].totalScore += assessment.total_score;
      groupScores[groupId][monthIndex].count += 1;
    });

    const dataset = Object.keys(groupScores).map((groupId, index) => {
      const groupData = groupScores[groupId];
      const averageScores = groupData.map(month => month.count > 0 ? month.totalScore / month.count : 0);

      return {
        label: groupNames[groupId] || `Group ${groupId}`,
        data: averageScores,
        backgroundColor: colorPalette[index % colorPalette.length],
        borderColor: colorPalette[index % colorPalette.length].replace('0.6', '1'),
        borderWidth: 1,
      };
    });

    return {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: dataset,
    };
  };



  const chartOptionsSecondgraph = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Average Score',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Month',
        },
      },
    },
  };

  const handleYearChangeSecondgraph = (event) => {
    setSelectedYearSecondGraph(event.target.value);
  };





  const handleGroupChangeSecondgraph = (event) => {
    const value = event.target.value;
    if (value.includes("all")) {
      setSelectedGroupSecondgraph(["all"]);
      setAvailableZonesSecondGraph([]);
      setSelectSecondAllZones(true);
    } else {
      setSelectedGroupSecondgraph(value);
      setSelectSecondAllZones(false);
      fetchZonesForGroupTwo();
    }
  };

  // const handleZoneChangeSecondgraph = (event) => {
  //   setSelectedZoneSecondgraph(event.target.value);
  // };
  const handleZoneChangeSecondgraph = (event) => {
    const value = event.target.value;

    // If the user deselects all zones, we should also clear the selection
    if (value.includes("all")) {
      setSelectedZoneSecondgraph(["all"]); // Select "all zones" if that option is chosen
    } else {
      setSelectedZoneSecondgraph(value);
    }
  };





  const calculateScores = (details) => {
    const data = JSON.parse(details).selectedValues;
    const positiveScores = Object.values(data).filter(
      (value) => value === "1"
    ).length;
    const negativeScores = Object.values(data).filter(
      (value) => value === "0"
    ).length;
    return { positiveScores, negativeScores };
  };

  const getChartData = () => {
    if (!chartData) return { labels: [], datasets: [] };

    const allMonths = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December",
    ];

    // Create an object with month names as keys and scores as values, defaulting to 0 if missing
    const monthScores = allMonths.reduce((acc, month) => {
      const item = chartData.find(i => i.month_name.trim() === month);
      acc[month] = item ? item.total_score : 0; // Assign score or 0 if missing
      return acc;
    }, {});

    return {
      labels: allMonths, // All months as x-axis labels
      datasets: [
        {
          label: "Assessment Scores",
          data: allMonths.map(month => monthScores[month]), // Use monthScores to get data
          backgroundColor: allMonths.map(
            month => (monthScores[month] >= 27 ? "#2ECC71" : "#F8392F") // Conditional color based on score
          ),
          borderColor: allMonths.map(
            month => (monthScores[month] >= 27 ? "#2ECC71" : "#F8392F") // Border color based on score
          ),
          borderWidth: 2,
        },
      ],
    };
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        anchor: "end",
        align: "top",
        color: "#444",
        font: {
          weight: "bold",
          size: 12,
        },
        display: false,
      },
      legend: {
        display: true,
        position: 'bottom',
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            const zone = uniqueZones[tooltipItem.datasetIndex];
            return zone.zone_leader_name; // Display full name on hover
          },
        },
        position: "nearest",
      },
    },

    scales: {
      x: {
        barPercentage: 0.5, // Controls the width of the bars (lower value makes bars thinner)
        categoryPercentage: 0.8,
      },
    },
    animation: {
      onComplete: function () {
        drawCircularAvatars(this); // Draw circular avatars after chart is complete
      },
    },
  };


  const zoneleaderChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        barPercentage: 0.5,
        categoryPercentage: 0.8,
        barThickness: 42, // Fixed bar width
      },
      y: {
        beginAtZero: true, // Ensure y-axis starts from 0
      },
    },
    plugins: {
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          // Customize legend labels if needed
          boxWidth: 20, // Size of the box that corresponds to the color
          padding: 15,
        },
      },
      annotation: {
        annotations: {
          line1: {
            type: "line",
            yMin: 32, // Position of the line on the y-axis
            yMax: 32,
            borderColor: "blue",
            borderWidth: 1,
            borderDash: [9, 9], // Dotted line
            label: {
              enabled: true,
              content: "Target: 32",
              position: "end",
              color: "blue",
              font: {
                size: 12,
                weight: "bold",
              },
            },
          },
          line2: {
            type: "line",
            yMin: 27,
            yMax: 27,
            borderColor: "red",
            borderWidth: 1,
            borderDash: [9, 9], // Dotted line
            label: {
              enabled: true,
              content: "Threshold: 27",
              position: "end",
              color: "red",
              font: {
                size: 12,
                weight: "bold",
              },
            },
          },
        },
      },
    },
  };

  const getTotalAudits = () => 12; // Static count of total audits

  const getCompletedAuditsCount = () => {
    return (chartData || []).filter((item) => item.status_flg === "C").length;
  };

  const getPendingAuditsCount = () => {
    const totalAudits = getTotalAudits();
    const completedCount = getCompletedAuditsCount();
    return totalAudits - completedCount; // Calculate pending audits based on total - completed
  };



  const getAveragePositiveScores = () => {
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return "0"; // Return 0 if chartData is null, not an array, or empty
    }

    const totalScores = chartData.reduce((sum, item) => {
      const { positiveScores } = calculateScores(item.details);
      return sum + positiveScores;
    }, 0);

    return (totalScores / chartData.length).toFixed(1);
  };


  const getLatestTotalScore = () => {
    return chartData && chartData.length > 0
      ? chartData[chartData.length - 1].total_score
      : 0;
  };

  const getTotalAuditsGroup = () => {
    const numberOfZones = zones.length; // Get the number of zones from state
    return 12 * numberOfZones; // Total audits as 12 * number of zones
  };

  const getCompletedAuditsCountGroup = () => {
    return (groupLeaderChartData || []).filter(
      (item) => item.status_flag === "C"
    ).length;
  };

  const getPendingAuditsCountGroup = () => {
    const totalAudits = getTotalAuditsGroup();
    const completedCount = getCompletedAuditsCountGroup();
    return totalAudits - completedCount; // Calculate pending audits
  };

  const getAveragePositiveScoresGroup = () => {
    if (!groupLeaderChartData || !Array.isArray(groupLeaderChartData)) return 0; // Return 0 if chartData is null or not an array

    const totalScores = groupLeaderChartData.reduce((sum, item) => {
      const { positiveScores } = calculateScores(item.details); // Make sure calculateScores is defined
      return sum + positiveScores;
    }, 0);

    const completedCount = getCompletedAuditsCountGroup(); // Get the count of completed audits
    return completedCount > 0 ? (totalScores / completedCount).toFixed(1) : 0; // Avoid division by zero
  };

  const getUniqueZones = (data) => {
    const uniqueZones = [];
    const colors = ["#17428B", "#FFA500", "#FF6347", "#32CD32"]; // Add more colors if needed
    data.forEach((item) => {
      if (!uniqueZones.some((zone) => zone.zone_id === item.zone_id)) {
        uniqueZones.push({
          ...item,
          color: colors[uniqueZones.length % colors.length], // Assign unique colors
        });
      }
    });
    return uniqueZones;
  };
  const allMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const uniqueZones = getUniqueZones(groupLeaderChartData);
  const getGroupLeaderChartData = () => {
    if (!groupLeaderChartData.length)
      return {
        labels: allMonths,
        datasets: [],
      };

    // Group data by month and zone
    const groupedData = groupLeaderChartData.reduce((acc, item) => {
      const month = item.month_name.trim();
      if (!acc[month]) acc[month] = {};
      acc[month][item.zone_id] = item.total_score;
      return acc;
    }, {});

    return {
      labels: allMonths, // Ensures all months appear as labels
      datasets: uniqueZones.map((zone) => ({
        label: zone.zone_name,
        backgroundColor: zone.color,
        borderColor: zone.color,
        data: allMonths.map((month) => groupedData[month]?.[zone.zone_id] || 0), // Assign 0 if no data for that month
        borderWidth: 2,
      })),
    };
  };
  const drawCircularAvatars = (chart) => {
    const ctx = chart.ctx;
    const { datasets } = chart.data;

    datasets.forEach((dataset, datasetIndex) => {
      const zone = uniqueZones[datasetIndex]; // Ensure uniqueZones is correctly indexed
      if (!zone) return; // Skip if zone is not found

      // Get the initials of the zone leader
      const initials = `${zone.zone_leader_name.charAt(0)}${zone.zone_leader_name.split(" ").pop().charAt(0)}`.toUpperCase();

      // Iterate over each value in the dataset and draw the avatar
      dataset.data.forEach((value, index) => {
        if (value > 0) { // Only draw for bars with values
          const bar = chart.getDatasetMeta(datasetIndex).data[index];
          const { x, y } = bar.tooltipPosition(); // Get the position of the bar

          // Draw the circular avatar
          const radius = 15; // Size of the avatar
          ctx.fillStyle = zone.color || '#1890FF'; // Set the background color (fallback if color is not defined)
          ctx.beginPath();
          ctx.arc(x, y - 20, radius, 0, Math.PI * 2); // Adjust the Y position as needed
          ctx.fill();

          // Draw the initials inside the circle
          ctx.fillStyle = "#fff"; // Text color
          ctx.font = "bold 12px sans-serif"; // Font style
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(initials, x, y - 20); // Adjust the position for initials
        }
      });
    });
  };


  const getUniqueMonths = (data) => {
    const uniqueMonths = [];
    data.forEach((item) => {
      if (!uniqueMonths.some((month) => month === item.month_name)) {
        uniqueMonths.push(item.month_name);
      }
    });
    return uniqueMonths;
  };

  const handleDownloadRowgrouptable = async (zoneId, auditDate) => {
    try {
      const response = await axios.get(`${ApiURL}/download-excel-reports`, {
        headers: { Authorization: `Bearer ${access_token}` },
        params: { zoneId, auditDate },
        responseType: "blob", // Add this line
      });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = `Zone_${zoneId}_Audit_${auditDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading excel file:", error);
    }
  };

  const handleDownloadRowZonetable = async (zoneId, auditDate) => {
    // console.log("zoneId, auditDate down", zoneId, auditDate)
    try {
      const response = await axios.get(`${ApiURL}/download-excel-reports`, {
        headers: { Authorization: `Bearer ${access_token}` },
        params: { zoneId, auditDate },
        responseType: "blob", // Add this line
      });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = `Zone_${zoneId}_Audit_${auditDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading excel file:", error);
    }
  };

  const getAveragePositiveScoresForMonth = (month) => {
    const scores = groupLeaderChartData
      .filter((item) => item.month_name === month)
      .map((item) => calculateScores(item.details).positiveScores);
    const totalScores = scores.reduce((sum, score) => sum + score, 0);
    return scores.length > 0 ? (totalScores / scores.length).toFixed(1) : 0;
  };

  // Helper function to calculate average negative scores for a specific month
  const getAverageNegativeScoresForMonth = (month) => {
    const scores = groupLeaderChartData
      .filter((item) => item.month_name === month)
      .map((item) => calculateScores(item.details).negativeScores);
    const totalScores = scores.reduce((sum, score) => sum + score, 0);
    return scores.length > 0 ? (totalScores / scores.length).toFixed(1) : 0;
  };

  const getAveragePositiveScoresForGroup = (groupData) => {
    const scores = groupData.map((item) => calculateScores(item.details).positiveScores);
    const totalScores = scores.reduce((sum, score) => sum + score, 0);
    return scores.length > 0 ? (totalScores / scores.length).toFixed(1) : 0;
  };

  // Helper function to calculate average negative scores for a specific group
  const getAverageNegativeScoresForGroup = (groupData) => {
    const scores = groupData.map((item) => calculateScores(item.details).negativeScores);
    const totalScores = scores.reduce((sum, score) => sum + score, 0);
    return scores.length > 0 ? (totalScores / scores.length).toFixed(1) : 0;
  };

  const exportToExcel = (month) => {
    const monthData = groupLeaderChartData.filter(
      (item) => item.month_name === month
    );

    // Prepare the data for Excel export
    const exportData = monthData.map((item) => ({
      "Zone Name": item.zone_name,
      "Zone Code": item.zone_code,
      "Audited By": item.auditor_name,
      "Audited On": new Date(item.audit_date).toLocaleDateString(),
      "Positive Scores": calculateScores(item.details).positiveScores,
      "Negative Scores": calculateScores(item.details).negativeScores,
      "Score Status":
        calculateScores(item.details).positiveScores >= 31
          ? "High Score Zone"
          : "Low Score Zone",
    }));

    // Create a worksheet from the data
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Create a workbook and append the worksheet to it
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `${month} Data`);

    // Trigger a download of the workbook
    XLSX.writeFile(wb, `${month}_Data.xlsx`);
  };

  const renderGroupLeaderTable = () => {
    const uniqueMonths = getUniqueMonths(groupLeaderChartData);

    return (
      <div>
        {/* Table Header */}
        <TableContainer component={Paper} sx={{ margin: '0', padding: '0' }} elevation={0}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '20%' }}>Month</TableCell>
                <TableCell sx={{ width: '30%' }}>Group Name</TableCell>
                <TableCell sx={{ width: '20%' }}>Total Positive Scores</TableCell>
                <TableCell sx={{ width: '20%' }}>Total Negative Scores</TableCell>
                <TableCell sx={{ width: '10%' }}>Action</TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>

        {/* Accordions for each month */}
        {uniqueMonths.map((month, index) => {
          const monthData = groupLeaderChartData.filter(
            (item) => item.month_name === month
          );
          const groupName = monthData[0]?.group_name || "Unknown Group";
          const averagePositiveScore = getAveragePositiveScoresForMonth(month);
          const averageNegativeScore = getAverageNegativeScoresForMonth(month);

          return (
            <Accordion key={month} sx={{ margin: '0', padding: '0' }} elevation={0}>
              <AccordionSummary
                // expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel-${index}-content`}
                id={`panel-${index}-header`}
                sx={{ margin: '0', padding: '0' }} elevation={0}
              >
                {/* Nested Table in AccordionSummary for Alignment */}
                <TableContainer sx={{ margin: '0', padding: '0' }} elevation={0}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ width: '20%' }}>{month}</TableCell>
                        <TableCell sx={{ width: '30%' }}>{groupName}</TableCell>
                        <TableCell sx={{ width: '20%' }}>{averagePositiveScore}</TableCell>
                        <TableCell sx={{ width: '20%' }}>{averageNegativeScore}</TableCell>
                        <TableCell sx={{ width: '10%' }}>
                          <IconButton onClick={() => exportToExcel(month)}>
                            <GetAppIcon />
                          </IconButton>
                        </TableCell>{" "}
                        {/* Empty cell to align with Action header */}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>S.No</TableCell>
                        <TableCell>Zone Name</TableCell>
                        <TableCell>Zone Code</TableCell>
                        <TableCell>Audited By</TableCell>
                        <TableCell>Audited On</TableCell>
                        <TableCell>Positive Scores</TableCell>
                        <TableCell>Negative Scores</TableCell>
                        <TableCell>Score Status</TableCell>
                        <TableCell>Download</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {monthData.map((item, i) => {
                        const { positiveScores, negativeScores } =
                          calculateScores(item.details);
                        const formattedDate = new Date(
                          item.audit_date
                        ).toLocaleDateString();
                        return (
                          <TableRow key={item.assessment_id}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell>{item.zone_name}</TableCell>
                            <TableCell>{item.zone_code}</TableCell>
                            <TableCell>{item.auditor_name}</TableCell>
                            <TableCell>{formattedDate}</TableCell>
                            <TableCell>
                              {positiveScores}
                              {positiveScores >= 31 && (
                                <FontAwesomeIcon
                                  icon={faArrowCircleUp}
                                  style={{ color: "green", marginLeft: "8px" }}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {negativeScores}
                              {positiveScores < 31 && (
                                <FontAwesomeIcon
                                  icon={faArrowCircleDown}
                                  style={{ color: "red", marginLeft: "8px" }}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  backgroundColor:
                                    positiveScores >= 31
                                      ? "#34C7591A"
                                      : "#E4003A1A",
                                  color:
                                    positiveScores >= 31
                                      ? "#34C759"
                                      : "#E4003A",
                                }}
                              >
                                {positiveScores >= 31
                                  ? "High Score Zone"
                                  : "Low Score Zone"}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <IconButton
                                onClick={() =>
                                  handleDownloadRowgrouptable(
                                    item.zone_id,
                                    item.audit_date
                                  )
                                }
                              >
                                <GetAppIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    );
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const downloadCSV = () => {
    // Calculate grouped data within this function
    const groupedData = groupLeaderChartData.reduce((acc, item) => {
      const month = item.month_name.trim();
      if (!acc[month]) acc[month] = {};
      acc[month][item.zone_id] = item.total_score;
      return acc;
    }, {});

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent +=
      ["Month", ...uniqueZones.map((zone) => zone.zone_name)].join(",") + "\n";

    allMonths.forEach((month) => {
      const row = [
        month,
        ...uniqueZones.map((zone) => groupedData[month]?.[zone.zone_id] || 0),
      ];
      csvContent += row.join(",") + "\n";
    });

    const blob = new Blob([decodeURIComponent(encodeURI(csvContent))], {
      type: "text/csv;charset=utf-8;",
    });
    FileSaver.saveAs(blob, "chart-data.csv");
  };

  const downloadPNG = () => {
    htmlToImage
      .toPng(document.getElementById("chartContainer"))
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "chart.png";
        link.href = dataUrl;
        link.click();
      });
  };

  const downloadSVG = () => {
    htmlToImage
      .toSvg(document.getElementById("chartContainer"))
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "chart.svg";
        link.href = dataUrl;
        link.click();
      });
  };

  const handleMenuZoneClick = (event) => {
    setZoneAnchorEl(event.currentTarget);
  };

  const handleMenuZoneClose = () => {
    setZoneAnchorEl(null);
  };

  const downloadAsCSV = () => {
    const csv = Papa.unparse(chartData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "chart-data.csv";
    link.click();
  };

  const downloadAsPNG = () => {
    const node = document.getElementById("chart-container");
    htmlToImage.toPng(node).then((dataUrl) => {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "chart-image.png";
      link.click();
    });
  };

  const downloadAsSVG = () => {
    const node = document.getElementById("chart-container");
    htmlToImage.toSvg(node).then((dataUrl) => {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "chart-image.svg";
      link.click();
    });
  };

  const handleNextImage = () => {
    if (latestMassFive.length > 0) {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % latestMassFive.length
      ); // Loop to first image when reaching the end
    }
  };

  // Navigate to previous image
  const handlePrevImage = () => {
    if (latestMassFive.length > 0) {
      setCurrentImageIndex(
        (prevIndex) =>
          (prevIndex - 1 + latestMassFive.length) % latestMassFive.length // Loop to last image when going backward
      );
    }
  };

  const generateChartData = () => {
    const monthlyGroupData = {};

    // Step 1: Group data by month and ass_group_id, calculate average total score
    coordinatorChartData.forEach((entry) => {
      const month = parseInt(entry.audit_month, 10); // Convert month to an integer
      const groupId = entry.ass_group_id;

      // Initialize data structure if it doesn't exist
      if (!monthlyGroupData[month]) monthlyGroupData[month] = {};
      if (!monthlyGroupData[month][groupId]) {
        monthlyGroupData[month][groupId] = { totalScore: 0, count: 0 };
      }

      // Accumulate total score and count for each group in each month
      monthlyGroupData[month][groupId].totalScore += entry.total_score;
      monthlyGroupData[month][groupId].count += 1;
    });

    // Step 2: Get all unique ass_group_ids across all months
    const uniqueGroupIds = [
      ...new Set(coordinatorChartData.map((item) => item.ass_group_id)),
    ];

    // Step 3: Generate unique colors for each ass_group_id
    const colors = uniqueGroupIds.map(
      (_, index) => `hsl(${index * 60}, 70%, 50%)`
    );

    // Step 4: Prepare chart data format with average scores for each ass_group_id per month
    const labels = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const groupNameMap = Object.fromEntries(
      availableGroups.map((group) => [group.group_id, group.group_name])
    );
    // Step 5: Build dataset for each ass_group_id
    const datasets = uniqueGroupIds.map((groupId, idx) => {
      const data = labels.map((_, monthIndex) => {
        const monthData = monthlyGroupData[monthIndex + 1]; // monthIndex + 1 to match month (1-12)
        const groupData = monthData ? monthData[groupId] : null;
        return groupData ? groupData.totalScore / groupData.count : null; // Calculate average if data exists
      });

      return {
        label: groupNameMap[groupId] || `Group ${groupId}`,
        // label: `Group ${groupId}`,
        backgroundColor: colors[idx], // Unique color for each group
        data: data,
      };
    });

    // Step 6: Return the chart data
    return { labels, datasets };
  };

  const chartOptionscoord = {
    responsive: true,

    scales: {
      x: {
        stacked: false, // Set to false to avoid stacking bars, allowing separate bars for each group
        barPercentage: 0.7, // Adjust bar width
        categoryPercentage: 0.8, // Adjust spacing between bars for different groups
      },
      y: {
        beginAtZero: true,
        ticks: {
          beginAtZero: true,
          stepSize: 5, // Adjust step size for Y-axis
        },
      },
    },
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Monthly Average Score by Group" },
    },

  };

  useEffect(() => {
    fetchCoordinatorData();
  }, [selectedGroup, selectedYear]);
  const handleYearCoordChange = (event) => {
    const newYear = event.target.value;
    setSelectedYear(newYear);
  };

  const generateChartDataFirstgraph = () => {
    const monthlyScores = Array(12)
      .fill(0)
      .map(() => ({ totalScore: 0, count: 0 }));

    coordinatorFirstChData.forEach((assessment) => {
      const monthIndex = parseInt(assessment.audit_month) - 1;
      monthlyScores[monthIndex].totalScore += assessment.total_score;
      monthlyScores[monthIndex].count += 1;
    });

    const averageScores = monthlyScores.map((month) =>
      month.count > 0 ? month.totalScore / month.count : 0
    );

    return {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "Average Score",
          data: averageScores,
          backgroundColor: "rgba(0, 123, 255, 0.6)",
          borderColor: "rgba(0, 123, 255, 1)",
          borderWidth: 1,
        },
      ],
    };
  };
  const chartOptionsFirstgraph = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Average Score",
        },
      },
      x: {
        title: {
          display: true,
          text: "Month",
        },
      },
    },
  };

  const handleGroupChange = (event) => {
    const newGroup = event.target.value;
    setSelectedGroup(newGroup === "all" ? "all" : newGroup); // When "all" is selected, fetch data for all groups
  };
  // Define a function to generate colors dynamically
 
  useEffect(() => {
    if (isCoordinator || isWcmhead ||isPlanthead) {
      fetchCoordinatorDataPieChart(selectedYearPieCoord, selectedMonthPieCoord);
    }

  }, [selectedYearPieCoord, selectedMonthPieCoord, isCoordinator,isWcmhead,isPlanthead]);

const fetchCoordinatorDataPieChart = async (year, month) => {
  setLoading(true);
  try {
    const selectedPlantId = localStorage.getItem("selectedPlantId");

    const zoneGroupIds = userRole
      .filter(user => 
        user.zone_group_id &&
        (user.wcm_coordinatorname || user.wcm_headlastname || user.plant_headlastname)
      )
      .map(user => user.zone_group_id);

    const response = await axios.post(`${ApiURL}/get_dashboard_piecoord`, {
      plantId: selectedPlantId,
      year,
      month,
      zoneGroupIds // send as array
    }, {
      headers: { Authorization: `Bearer ${access_token}` }
    });

    const completedAssessments = response.data.filter(
      (assessment) => assessment.status_flag === "C"
    );
    setCoordinatorChartDataPie(completedAssessments);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching coordinator data:", error);
  } finally {
    setLoading(false);
  }
};

  //prod code
  // const fetchCoordinatorDataPieChart = async (year, month) => {
  //   setLoading(true);
  //   try {
  //     const selectedPlantId = localStorage.getItem("selectedPlantId");

     
  //     const zoneGroupIds = userRole
  //     .filter(user => 
  //       user.zone_group_id &&
  //       (user.wcm_coordinatorname || user.wcm_headlastname||user.plant_headlastname)
  //     )
  //     .map(user => user.zone_group_id)
  //     .join(',');

  //     const response = await axios.get(`${ApiURL}/get_dashboard_piecoord`, {
  //       params: {
  //         plantId: selectedPlantId,
  //         year: year,
  //         month: month,
  //         zoneGroupIds: zoneGroupIds, // Pass zone_group_ids
  //       },
  //       headers: { Authorization: `Bearer ${access_token}` },
  //     });

  //     const completedAssessments = response.data.filter(
  //       (assessment) => assessment.status_flag === "C"
  //     );
  //     setCoordinatorChartDataPie(completedAssessments);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching coordinator data:", error);
  //     setLoading(false);
  //   }
  // };


  //test code2
  const calculateAverageScores = (assessments, selectedMonth, selectedYear) => {
    // Group assessments by `ass_group_id`
    const totalScoresByGroup = assessments.reduce((acc, audit) => {
      // Initialize the group if not present
      if (!acc[audit.ass_group_id]) {
        acc[audit.ass_group_id] = {
          totalScore: 0,
          count: 0,
          groupName: audit.group_name,
        };
      }

      // Accumulate scores only for the selected month and year
      if (
        parseInt(audit.audit_month) === parseInt(selectedMonth) &&
        parseInt(audit.audit_year) === parseInt(selectedYear)
      ) {
        acc[audit.ass_group_id].totalScore += audit.total_score;
        acc[audit.ass_group_id].count += 1;
      }

      return acc;
    }, {});

    // Map the results into a consumable array format
    return Object.entries(totalScoresByGroup).map(
      ([assGroupId, { totalScore, count, groupName }]) => ({
        assGroupId,
        groupName,
        averageScore: count > 0 ? (totalScore / count).toFixed(1) : "0.0", // Calculate average
      })
    );
  };

  // Use the function with the API response
  const totalScores = calculateAverageScores(coordinatorChartDataPie, selectedMonthPieCoord, selectedYearPieCoord);

  // Log the result
  console.log("Average Scores by Group:", totalScores);
  const calculateOverallAverageCooPie = (groupData) => {
    // Calculate total sum of averages and count of valid entries
    const { total, count } = groupData.reduce(
      (acc, group) => {
        const avgScore = parseFloat(group.averageScore); // Convert averageScore to number
        if (!isNaN(avgScore)) {
          acc.total += avgScore; // Add to total
          acc.count += 1;        // Increment count
        }
        return acc;
      },
      { total: 0, count: 0 } // Initial accumulator values
    );

    // Calculate overall average
    return count > 0 ? (total / count).toFixed(1) : "0.0";
  };

  // Calculate overall average
  const overallAverageScore = calculateOverallAverageCooPie(totalScores);

  // Log the result
  console.log("Overall Average Score:", overallAverageScore);

  // You can display `totalScores` in your UI as required.






  //roopa code


  // const totalScoresByGroup = coordinatorChartDataPie.reduce((acc, audit) => {
  //   // Check if the group_id already exists in the accumulator
  //   if (!acc[audit.ass_group_id]) {
  //     acc[audit.ass_group_id] = {
  //       totalScore: 0,
  //       count: 0,
  //       groupName: audit.group_name,
  //       audit_month: audit.audit_month,
  //       audit_year: audit.audit_year
  //     }; // Add group_name from the audit
  //   }

  //   // Add to totalScore and count for the corresponding group_id

  //   acc[audit.ass_group_id].totalScore += audit.total_score;
  //   acc[audit.ass_group_id].count += 1;

  //   return acc;
  // }, {});
  // const totalScores = Object.entries(totalScoresByGroup).map(
  //   ([assGroupId, { totalScore, count, groupName, audit_month, audit_year }]) => {
  //     const averageScore = (totalScore / count).toFixed(1); // rounding to 2 decimal places
  //     return { assGroupId, groupName, totalScore, averageScore, audit_month, audit_year };
  //   }
  // );
  // console.log(coordinatorChartDataPie, "coordinatorChartDataPie")
  console.log("TOTAL", totalScores);
  const handleYearChangePieCoord = (event) => {
    setSelectedYearPieCoord(event.target.value);
  };

  const handleMonthChangePieCoord = (event) => {
    setSelectedMonthPieCoord(event.target.value);
  };
  // newly added 


  // radar chart start
  useEffect(() => {
    fetchYears();
    // Fetch the current month and year initially
    const currentMonth = new Date().getMonth() + 1; // Months are 0-indexed in JS
    const currentYear = new Date().getFullYear();

    // Fetch data with current month and year by default
    fetchCoordinatorRadarChart(currentYear, [currentMonth]);
  }, []);

  const fetchCoordinatorRadarChart = async (year, months) => {
  try {
    const selectedPlantId = localStorage.getItem("selectedPlantId");

    // Get zoneGroupIds directly as an array
    const zoneGroupIds = userRole
      .filter(user => 
        user.zone_group_id &&
        (user.wcm_coordinatorname || user.wcm_headlastname || user.plant_headlastname)
      )
      .map(user => user.zone_group_id);

    // Perform POST request
    const response = await axios.post(
      `${ApiURL}/get_radar_chart_data`,
      {
        plantId: selectedPlantId,
        year,
        month: months,          // Should be an array of numbers
        zoneGroupIds: zoneGroupIds // Already an array
      },
      {
        headers: { Authorization: `Bearer ${access_token}` }
      }
    );

    const completedAssessments = response.data.filter(
      (assessment) => assessment.status_flag === "C"
    );

    const totalScoresByGroupRadar = completedAssessments.reduce((acc, audit) => {
      const groupKey = `${audit.ass_group_id}-${audit.audit_month}`;
      if (!acc[groupKey]) {
        acc[groupKey] = {
          assGroupId: audit.ass_group_id,
          groupName: audit.group_name,
          audit_month: audit.audit_month,
          totalScore: 0,
          count: 0,
        };
      }
      acc[groupKey].totalScore += audit.total_score;
      acc[groupKey].count += 1;
      return acc;
    }, {});

    const totalScoresRadar = Object.values(totalScoresByGroupRadar).map(
      ({ assGroupId, groupName, audit_month, totalScore, count }) => ({
        assGroupId,
        groupName,
        audit_month,
        averageScore: (totalScore / count).toFixed(1),
      })
    );

    setCoordinatorRadarData(totalScoresRadar);
  } catch (error) {
    console.error("Error fetching coordinator data:", error);
  }
};
//prod code
  // const fetchCoordinatorRadarChart = async (year, months) => {
  //   try {
  //     const selectedPlantId = localStorage.getItem("selectedPlantId");
      
  //     const zoneGroupIds = userRole
  //     .filter(user => 
  //       user.zone_group_id &&
  //       (user.wcm_coordinatorname || user.wcm_headlastname ||user.plant_headlastname)
  //     )
  //     .map(user => user.zone_group_id)
  //     .join(',');
  //     const response = await axios.get(`${ApiURL}/get_radar_chart_data`, {
  //       params: {
  //         plantId: selectedPlantId,
  //         year: year,
  //         month: months,
  //         zoneGroupIds: zoneGroupIds // Pass months as an array directly
  //       },
  //       headers: { Authorization: `Bearer ${access_token}` },
  //     });

  //     const completedAssessments = response.data.filter(
  //       (assessment) => assessment.status_flag === "C"
  //     );

  //     const totalScoresByGroupRadar = completedAssessments.reduce((acc, audit) => {
  //       const groupKey = `${audit.ass_group_id}-${audit.audit_month}`;
  //       if (!acc[groupKey]) {
  //         acc[groupKey] = {
  //           assGroupId: audit.ass_group_id,
  //           groupName: audit.group_name,
  //           audit_month: audit.audit_month,
  //           totalScore: 0,
  //           count: 0,
  //         };
  //       }
  //       acc[groupKey].totalScore += audit.total_score;
  //       acc[groupKey].count += 1;
  //       return acc;
  //     }, {});

  //     const totalScoresRadar = Object.values(totalScoresByGroupRadar).map(
  //       ({ assGroupId, groupName, audit_month, totalScore, count }) => ({
  //         assGroupId,
  //         groupName,
  //         audit_month,
  //         averageScore: (totalScore / count).toFixed(1),
  //       })
  //     );

  //     setCoordinatorRadarData(totalScoresRadar);
  //   } catch (error) {
  //     console.error("Error fetching coordinator data:", error);
  //   }
  // };


  useEffect(() => {
    if (isCoordinator|| isWcmhead ||isPlanthead) {
      fetchCoordinatorRadarChart(selectedYearRadar, selectedMonthsRadar);
    }
  }, [selectedYearRadar, selectedMonthsRadar, isCoordinator,isWcmhead,isPlanthead]);






  const handleYearChangeFirstgraph = (event) => {
    const newYear = event.target.value;
    setSelectedYearFirstGraph(newYear);
    fetchCoordinatorDataOne(newYear, selectedGroupFirstgraph, selectedZoneFirstgraph);
  };

  // const handleGroupChangeFirstgraph = (event) => {
  //   const newGroup = event.target.value;
  //   setSelectedGroupFirstgraph(newGroup);
  //   fetchZonesForGroup(newGroup);
  //   setSelectedZoneFirstgraph([]);  // Reset zone selection
  //   setSelectAllZones(false);  // Reset "Select All Zones" checkbox
  // };
  const handleGroupChangeFirstgraph = (event) => {
    const newGroup = event.target.value;
    setSelectedGroupFirstgraph(newGroup);
    setSelectedZoneFirstgraph([]); // Reset zone selection
    fetchZonesForGroup(newGroup);
    setSelectAllZones(false); 
    let groupIds = newGroup === "all" ? uniqueZoneGroupIds : [newGroup];
    fetchCoordinatorDataOne(selectedYearFirstgraph, groupIds, []);
};


  const handleZoneChangeFirstgraph = (event) => {
    const newZone = event.target.value;
    setSelectedZoneFirstgraph(newZone);
    fetchCoordinatorDataOne(selectedYearFirstgraph, selectedGroupFirstgraph, newZone);
  };

  const handleZoneSelection = (zoneId) => {
    const newSelectedZones = selectedZoneFirstgraph.includes(zoneId)
      ? selectedZoneFirstgraph.filter(zone => zone !== zoneId)
      : [...selectedZoneFirstgraph, zoneId];

    setSelectedZoneFirstgraph(newSelectedZones);
    setSelectAllZones(newSelectedZones.length === availableZonesFirstGraph.length);  // Check if all zones are selected
  };

  const handleSelectAllZones = () => {
    if (selectAllZones) {
      setSelectedZoneFirstgraph([]);  // Deselect all zones
    } else {
      setSelectedZoneFirstgraph(availableZonesFirstGraph.map(zone => zone.id));  // Select all zones
    }
    setSelectAllZones(!selectAllZones);  // Toggle "Select All Zones" checkbox
  };


  const exportGroupToExcel = (groupName, groupData, month) => {
    // Prepare the data for Excel
    const worksheetData = groupData.map((item, index) => ({
      'S.No': index + 1,
      'Zone Name': item.zone_name,
      'Zone Code': item.zone_code,
      'Audited Date': new Date(item.audit_date).toLocaleDateString(),
      'Audited By': item.auditor_name,
      'Positive Score': calculateScores(item.details).positiveScores,
      'Negative Score': calculateScores(item.details).negativeScores,
      'Score Status': calculateScores(item.details).positiveScores >= 31 ? 'High Score Zone' : 'Low Score Zone'
    }));

    // Create a new workbook and worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${groupName}`);

    // Export the file
    XLSX.writeFile(workbook, `${month}-${groupName}.xlsx`);
  };

  // Function to export an entire month to Excel
  const exportMonthToExcel = (month, monthData) => {
    // Prepare the data for Excel
    const worksheetData = monthData.map((item, index) => ({
      'Group Name': item.group_name,
      'Zone Name': item.zone_name,
      'Zone Code': item.zone_code,
      'Audited Date': new Date(item.audit_date).toLocaleDateString(),
      'Audited By': item.auditor_name,
      'Positive Score': calculateScores(item.details).positiveScores,
      'Negative Score': calculateScores(item.details).negativeScores,
      'Score Status': calculateScores(item.details).positiveScores >= 31 ? 'High Score Zone' : 'Low Score Zone'
    }));

    // Create a new workbook and worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${month}`);

    // Export the file
    XLSX.writeFile(workbook, `${month}.xlsx`);
  };


  const renderCoordinatorTable = () => {
    const getMonthName = (monthNumber) => {
      const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return months[monthNumber - 1];
    };

    // const uniqueMonths = [...new Set(coordinatorChartData.map(item => `${item.audit_month}-${item.audit_year}`))];
    const uniqueMonths = [...new Set(coordinatorChartData.map(item => `${item.audit_month}-${item.audit_year}`))]
      .sort((a, b) => {
        const [monthA, yearA] = a.split('-').map(Number);
        const [monthB, yearB] = b.split('-').map(Number);

        // Sort by year first, then by month
        return yearA - yearB || monthA - monthB;
      });
    let allAveragePositiveScores = [];
    return (
      <>
        {uniqueMonths.map((month, index) => {
          const [auditMonth, auditYear] = month.split('-');
          const monthName = getMonthName(Number(auditMonth));
          const monthData = coordinatorChartData.filter(
            (item) => item.audit_month === auditMonth && item.audit_year === auditYear
          );

          const uniqueGroups = [...new Set(monthData.map(item => item.group_name))];
          // const averageOfTotalPositiveScores = getAverageOfAveragePositiveScores(monthData);
          return (
            <div sx={{overflow:"auto",width:"100%"}}>
            
              {/* <AccordionTable monthData={monthData} uniqueGroups={uniqueGroups} monthName={monthName} auditYear={auditYear}/> */}

              <Accordion key={month} sx={{ margin: '0', padding: '0' }} elevation={0}>
                <AccordionSummary
                  // expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel-${index}-content`}
                  elevation={0}
                  id={`panel-${index}-header`}
                  sx={{ margin: '0', padding: '0', minHeight: 'auto!important' }}
                >
                  <TableContainer component={Paper} sx={{ margin: '0', padding: '0' }} elevation={0}>
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell  sx={{ }}>{`${monthName} ${auditYear}`}</TableCell>
                          <TableCell sx={{  }}>Group Name</TableCell>
                          <TableCell sx={{ }}>Total Positive Scores</TableCell>
                          <TableCell sx={{ }}>Total Negative Scores</TableCell>
                          <TableCell sx={{}}>Action</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* <IconButton onClick={() => exportMonthToExcel(`${monthName}-${auditYear}`, monthData)}>
                    <GetAppIcon />
                  </IconButton> */}
                </AccordionSummary>

                <AccordionDetails>
                  {uniqueGroups.map((groupName, groupIndex) => {
                    const groupData = monthData.filter(item => item.group_name === groupName);
                    const averagePositiveScore = getAveragePositiveScoresForGroup(groupData);
                    allAveragePositiveScores.push(averagePositiveScore);
                    const averageNegativeScore = getAverageNegativeScoresForGroup(groupData);

                    return (
                      <Accordion key={`${month}-${groupName}`} defaultExpanded sx={{ margin: '0', padding: '0' }}>
                        <AccordionSummary
                          sx={{ margin: '0', padding: '0' }}
                          // expandIcon={}
                          aria-controls={`panel-${index}-group-${groupIndex}-content`}
                          id={`panel-${index}-group-${groupIndex}-header`}
                        >
                          <TableContainer sx={{ margin: '0', padding: '0' }}>
                            <Table>
                              <TableBody>
                                <TableRow>
                                  <TableCell sx={{ width: '20%', margin: '0', padding: '0 16px', border: 'none' }}><ExpandMoreIcon /></TableCell>
                                  <TableCell sx={{ width: '20%', margin: '0', padding: '0 16px', border: 'none' }}>{groupName}</TableCell>
                                  <TableCell sx={{ width: '20%', margin: '0', padding: '0 16px', border: 'none' }}>{averagePositiveScore}</TableCell>
                                  <TableCell sx={{ width: '20%', margin: '0', padding: '0 16px', border: 'none' }}>{averageNegativeScore}</TableCell>
                                  <TableCell sx={{ width: '20%', margin: '0', padding: '0 16px', border: 'none' }}>
                                    <IconButton onClick={() => exportGroupToExcel(groupName, groupData, `${monthName}-${auditYear}`)}>
                                      <GetAppIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionSummary>

                        <AccordionDetails>
                          <TableContainer component={Paper}>
                            <Table>
                              <TableHead>
                                <TableRow sx={{ background: '#f8f9fb' }}>
                                  <TableCell>S.No</TableCell>
                                  <TableCell>Zone Name</TableCell>
                                  <TableCell>Zone Code</TableCell>
                                  <TableCell>Audited Date</TableCell>
                                  <TableCell>Audited By</TableCell>
                                  <TableCell>Positive Score</TableCell>
                                  <TableCell>Negative Score</TableCell>
                                  <TableCell>Score Status</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {groupData.map((item, rowIndex) => {
                                  const { positiveScores, negativeScores } = calculateScores(item.details);
                                  const formattedDate = new Date(item.audit_date).toLocaleDateString();
                                  return (
                                    <TableRow key={item.assessment_id}>
                                      <TableCell>{rowIndex + 1}</TableCell>
                                      <TableCell>{item.zone_name}</TableCell>
                                      <TableCell>{item.zone_code}</TableCell>
                                      <TableCell>{formattedDate}</TableCell>
                                      <TableCell>{item.auditor_name}</TableCell>
                                      <TableCell>
                                        {positiveScores}
                                        {positiveScores >= 31 && (
                                          <FontAwesomeIcon
                                            icon={faArrowCircleUp}
                                            style={{ color: "green", marginLeft: "8px" }}
                                          />
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {negativeScores}
                                        {positiveScores < 31 && (
                                          <FontAwesomeIcon
                                            icon={faArrowCircleDown}
                                            style={{ color: "red", marginLeft: "8px" }}
                                          />
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        <Box
                                          sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: positiveScores >= 31 ? "#34C7591A" : "#E4003A1A",
                                            color: positiveScores >= 31 ? "#34C759" : "#E4003A",
                                          }}
                                        >
                                          {positiveScores >= 31 ? "High Score Zone" : "Low Score Zone"}
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            </div>

          );
        })}
      </>
    );
  };


  const downloadCSVChart = () => {
    const chartData = generateChartData();
    const csvRows = [
      ["Month", ...chartData.datasets.map((dataset) => dataset.label)],
      ...chartData.labels.map((label, index) => [
        label,
        ...chartData.datasets.map((dataset) => dataset.data[index] ?? ""),
      ]),
    ];
    const csvContent = csvRows.map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    FileSaver.saveAs(blob, "chart-data.csv");
  };

  // Function to download chart as PNG
  const downloadPNGChart = () => {
    const chartElement = document.getElementById("chart");
    htmlToImage.toPng(chartElement)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "chart_data.png";
        link.click();
      })
      .catch((error) => {
        console.error("Failed to download PNG:", error);
      });
  };

  // Function to download chart as SVG
  const downloadSVGChart = () => {
    const chartElement = document.getElementById("chart");
    htmlToImage.toSvg(chartElement)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "chart_data.svg";
        link.click();
      })
      .catch((error) => {
        console.error("Failed to download SVG:", error);
      });
  };
  const handleMenuOpen = (event) => {
    setChartAnchorEl(event.currentTarget);
  };

  const handleMenuCloseChart = () => {
    setChartAnchorEl(null);
  };


  const handleMenuOpenFirst = (event) => {
    setChartFirstAnchorEl(event.currentTarget);
  };

  const handleMenuCloseFirstChart = () => {
    setChartFirstAnchorEl(null);
  };


  const downloadPNGFirstGraph = () => {
    const chartElement = document.getElementById("first-graph-chart");
    htmlToImage.toPng(chartElement).then((dataUrl) => {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "secondary_assessment_chart.png";
      link.click();
    }).catch((error) => {
      console.error("Failed to download PNG:", error);
    });
  };

  const downloadSVGFirstGraph = () => {
    const chartElement = document.getElementById("first-graph-chart");
    htmlToImage.toSvg(chartElement).then((dataUrl) => {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "secondary_assessment_chart.svg";
      link.click();
    }).catch((error) => {
      console.error("Failed to download SVG:", error);
    });
  };

  const downloadCSVFirstGraph = () => {
    const chartData = generateChartDataFirstgraph();
    const csvData = [
      ["Month", "Average Score"],
      ...chartData.labels.map((label, index) => [
        label,
        chartData.datasets[0].data[index],
      ]),
    ];

    const csvContent = csvData.map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    FileSaver.saveAs(blob, "secondary_assessment_chart.csv");
  };


  const downloadPNGSecondGraph = () => {
    const chartElement = document.getElementById("second-graph-chart");
    htmlToImage.toPng(chartElement)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "last_assessment_chart.png";
        link.click();
      })
      .catch((error) => {
        console.error("Failed to download PNG:", error);
      });
  };

  // Function to download chart as SVG
  const downloadSVGSecondGraph = () => {
    const chartElement = document.getElementById("second-graph-chart");
    htmlToImage.toSvg(chartElement)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "last_assessment_chart.svg";
        link.click();
      })
      .catch((error) => {
        console.error("Failed to download SVG:", error);
      });
  };

  // Function to download chart data as CSV
  const downloadCSVSecondGraph = () => {
    const chartData = generateChartDataSecondgraph();
    const csvData = [
      ["Month", ...chartData.datasets.map((dataset) => dataset.label)],
      ...chartData.labels.map((label, index) => [
        label,
        ...chartData.datasets.map((dataset) => dataset.data[index]),
      ]),
    ];

    const csvContent = csvData.map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(blob, "last_assessment_chart.csv");

  };

  const handleMenuOpenSecond = (event) => {
    setChartSecondAnchorEl(event.currentTarget);
  };

  const handleMenuCloseSecondChart = () => {
    setChartSecondAnchorEl(null);
  };

  //   const uniqueAssGroupIds = new Set(data.map(item => item.ass_group_id));
  // const uniqueAssGroupCount = uniqueAssGroupIds.size;

  // // Get unique zone_id count
  // const uniqueZoneIds = new Set(data.map(item => item.zone_id));
  // const uniqueZoneCount = uniqueZoneIds.size;
  const totalScorescoord = getAverageOfAveragePositiveScores(coordinatorChartData);
  const groupcountcoord = getGroupCounts(coordinatorChartData);
  // const zonecountcoord = getTotalZoneCounts(coordinatorChartData);
  const totplant = getTotalPlants();


  const handleMonthChangeElite = (event) => {
    setSelectedMonthElite(event.target.value);
  };

  const handleYearChangeElite = (event) => {
    setSelectedYearElite(event.target.value);
  };


  useEffect(() => {
    const currentMonth = new Date().getMonth() + 1; // Months are 0-based
    const currentYear = new Date().getFullYear();
    setSelectedMonthElite(currentMonth);
    setSelectedYearElite(currentYear);
  }, []);

  useEffect(() => {
    if (isCoordinator||isWcmhead||isPlanthead) {
      fetchReportData();

      fetchMonthsAndYears();
    }
  }, [selectedMonthElite, selectedYearElite, isCoordinator,isWcmhead,isPlanthead]);

  const fetchMonthsAndYears = async () => {
    try {
      const selectedPlantId = localStorage.getItem('selectedPlantId');
      const response = await axios.get(`${ApiURL}/get_available_months_and_years`, { headers: { Authorization: `Bearer ${access_token}` }, params: { selectedPlantId } });
      setMonthsAndYears(response.data);
    } catch (error) {
      console.error('Error fetching months and years:', error);
    }
  };


  const fetchReportData = async () => {
    try {
      const selectedPlantId = localStorage.getItem('selectedPlantId');
      const response = await axios.get(`${ApiURL}/get_dashboard_elite`, {
        headers: { Authorization: `Bearer ${access_token}` },
        params: { month: selectedMonthElite, year: selectedYearElite, selectedPlantId }
      });
      setEliteData(response.data);
    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };
  const filterDataByMonthAndYear = () => {
    return Elitedata.map(item => {
      // console.log("Item before filtering:", item);

      // Extract scores as numbers
      const scores = [
        parseFloat(item.selected_month_score),
        parseFloat(item.prev_month_score_1),
        parseFloat(item.prev_month_score_2),
        parseFloat(item.prev_month_score_3),
        parseFloat(item.prev_month_score_4),
        parseFloat(item.prev_month_score_5)
      ];

      // Check Elite Club condition
      const isEliteClub = parseFloat(item.total12monthspoints) > 31;

      // Check Elite Zone condition (all scores > 31)
      const isEliteZone = scores.every((score) => score > 31);

      // Return item with both tags
      return {
        ...item,
        isEliteClub,
        isEliteZone,
      };
    });
  };

  // Get filtered data with tags
  const filteredData = filterDataByMonthAndYear();

  // Separate into Elite Club and Elite Zone
  const eliteClubData = filteredData.filter(item => item.isEliteClub);
  const eliteZoneData = filteredData.filter(item => item.isEliteZone);
  const eliteClubCount = eliteClubData.length;
  const eliteZoneCount = eliteZoneData.length;
  console.log('Filtered Data:', filteredData);
  console.log('Elite Club Data:', eliteClubData);
  console.log('Elite Zone Data:', eliteZoneData);

  //old code
  // const filterDataByMonthAndYear = () => {
  //   return Elitedata.filter(item => {
  //     console.log("eliteData",Elitedata)
  //     console.log("Item before filtering:", item);
  //     // Check if all scores are greater than 31 for the selected range
  //     const scores = [
  //       parseFloat(item.selected_month_score),
  //       parseFloat(item.prev_month_score_1),
  //       parseFloat(item.prev_month_score_2),
  //       parseFloat(item.prev_month_score_3),
  //       parseFloat(item.prev_month_score_4),
  //       parseFloat(item.prev_month_score_5)
  //     ];

  //     // return scores.every(score => score > 31);
  //     const isEliteClub = parseFloat(item.total12monthspoints) > 31;

  //   // Check if all previous 6 months' scores are greater than 31
  //   const isEliteZone =

  //     scores.every((score) => score > 31) && scores[0] > 31;


  //     return {
  //       ...item,
  //       isEliteClub,
  //       isEliteZone,
  //     };

  //   });
  // };

  //   const filteredData = filterDataByMonthAndYear();
  //   console.log('Filtered Data:', filteredData); 
  // const eliteClubData = filteredData.filter((item) => item.isEliteClub);
  // console.log('Elite Club Data:', eliteClubData);
  // const eliteZoneData = filteredData.filter((item) => item.isEliteZone);
  // console.log('Elite Zone Data:', eliteZoneData);
  const countZonesWithHighScores = () => {
    return Elitedata.filter(item => {
      // Check if all previous month scores are greater than 31
      const scores = [
        parseFloat(item.selected_month_score),
        parseFloat(item.prev_month_score_1),
        parseFloat(item.prev_month_score_2),
        parseFloat(item.prev_month_score_3),
        parseFloat(item.prev_month_score_4),
        parseFloat(item.prev_month_score_5)
      ];
      return scores.every(score => score > 31); // Check if all scores are greater than 31
    }).length; // Return the count
  };
  return (
    <Box sx={{ background: '#fff' }}>
      <DashboardLayout
        totalScoresCoord={totalScorescoord}
        overallAverageScore={overallAverageScore}

        groupCountCoordinator={groupCount}

        zoneCountCoordinator={zoneCount}
        totalPlants={totplant}
        totalScoresCoordinator={totalScores}
        groupLeaderChartData={groupLeaderChartData}
        filteredDatagroupdata={filteredDatagroupdata}
        // totalScoresRadar={totalScoresRadar}
        totalScoresRadarCoordinator={coordinatorRadarData}
        selectedYearRadar={selectedYearRadar}
        setSelectedYearRadar={setSelectedYearRadar}
        selectedMonthsRadar={selectedMonthsRadar}
        setSelectedMonthsRadar={setSelectedMonthsRadar}
        years={years}
        isCoordinator={isCoordinator}
        isWcmhead={isWcmhead}
        isPlanthead={isPlanthead}
        isGroupLeader={isGroupLeader}
        firstName={firstName}
        lastName={lastName}
        latestMassFive={latestMassFive}
        currentImageIndex={currentImageIndex}
        handleNextImage={handleNextImage}
        handlePrevImage={handlePrevImage}

        totalAuditscard={getTotalCoordinatorCount()}
        totalAuditscardgrp={getTotalAuditsGroup()}

        avarageAuditcard={getAverageOfAveragePositiveScores(coordinatorChartData)}

        avarageAuditcardgrp={getAveragePositiveScoresGroup()}
        pendingAuditcard={getPendingAuditsCountCoordinator(coordinatorChartData)}
        pendingAuditcardgrp={getPendingAuditsCountGroup()}
        completedAuditcard={getCompletedAuditsCountCoordinator(coordinatorChartData)}
        completedAuditcardgrp={getCompletedAuditsCountGroup()}
        iszoneleader={iszoneleader}

        eliteClubData={eliteClubData}  // Pass Elite Club data
        eliteZoneData={eliteZoneData}

        eliteClubCount={eliteClubCount}
        eliteZoneCount={eliteZoneCount}
        canAccessDashboard={canAccessDashboard}
        groupNameInfo={groupNameInfo}
        handleYearChangePieCoord={handleYearChangePieCoord}
        handleMonthChangePieCoord={handleMonthChangePieCoord}
        selectedYearPieCoord={selectedYearPieCoord} // Pass the year value
        selectedMonthPieCoord={selectedMonthPieCoord}
        handleYearChangePieChartGroup={handleYearChangePieChartGroup}
        handleMonthChangePieChartGroup={handleMonthChangePieChartGroup}
        selectedYearPieGroup={selectedYearPieGroup}
        selectedMonthPieGroup={selectedMonthPieGroup}
        groupLeaderChartDataPie={groupLeaderChartDataPie}
       
        groupRadarData={groupRadarData}
            fetchGroupLeaderDataRadarchart={fetchGroupLeaderDataRadarchart}
            selectedYearGroupRadar={selectedYearGroupRadar}
            selectedMonthsGroupRadar={selectedMonthsGroupRadar}
            setSelectedYearGroupRadar={setSelectedYearGroupRadar}
            setSelectedMonthsGroupRadar={setSelectedMonthsGroupRadar}
            groupLeaderRole={groupLeaderRole} 
            zones={zones} 
      />



      <Box sx={{ padding: "0 16px" }}>

        {(isCoordinator || isWcmhead ||isPlanthead)? (
          <>



            <div>
              {/* Selection area */}
              <div style={{ justifyContent: 'flex-end', display: 'flex', marginBottom: '35px' }}>
                <Select
                  value={selectedMonthElite}
                  onChange={handleMonthChangeElite}
                  displayEmpty
                  sx={{
                    height: "32px",
                    fontSize: "14px",
                    padding: "4px 0px",
                    minWidth: "70px",
                    width: "auto",
                    flexShrink: 0, // Prevents shrinking
                  }}
                
                >
                  <MenuItem value="">
                    <em>Select Month</em>
                  </MenuItem>
                  <MenuItem value={1}>January</MenuItem>
                  <MenuItem value={2}>February</MenuItem>
                  <MenuItem value={3}>March</MenuItem>
                  <MenuItem value={4}>April</MenuItem>
                  <MenuItem value={5}>May</MenuItem>
                  <MenuItem value={6}>June</MenuItem>
                  <MenuItem value={7}>July</MenuItem>
                  <MenuItem value={8}>August</MenuItem>
                  <MenuItem value={9}>September</MenuItem>
                  <MenuItem value={10}>October</MenuItem>
                  <MenuItem value={11}>November</MenuItem>
                  <MenuItem value={12}>December</MenuItem>
                </Select>

                <Select
                  value={selectedYearElite}
                  onChange={handleYearChangeElite}
                  displayEmpty
                  sx={{
                    height: "32px",
                    fontSize: "14px",
                    padding: "4px 0px",
                    minWidth: "70px",
                    width: "auto",
                    flexShrink: 0, // Prevents shrinking
                  }}
                >
                  <MenuItem value="">
                    <em>Select Year</em>
                  </MenuItem>
                  {[...new Set(monthsAndYears.map((item) => item.year))].map((year, index) => (
                    <MenuItem key={index} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              {/* Card display area */}
              {/* <Grid container spacing={2}>
                {filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Card
                        sx={{
                          flex: 1,
                          marginX: 1,
                          padding: 2,
                          display: 'flex',
                          alignItems: 'flex-start',
                          justifyContent: 'center',
                          height: 'auto',
                          flexDirection: 'column',
                          boxShadow: 3,
                          borderRadius: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ fontSize: 16, marginBottom: 1 }}>
                          Zone: {item.name}
                        </Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#666' }}>
                          Zone Code: {item.code}
                        </Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#666' }}>
                          Group Leader: {item.grp_first} {item.grplast}
                        </Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#666' }}>
                          Zone Leader: {item.zone_first} {item.zonelast}
                        </Typography>
                        <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #ddd' }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#555' }}>
                            Scores:
                          </Typography>
                          <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#666' }}>
                            Selected Month: {item.selected_month_score}
                          </Typography>

                        </div>
                      </Card>
                    </Grid>
                  ))
                ) : (
                  <Typography variant="body1" color="textSecondary">
                    No zones with all scores greater than 31 in the selected range.
                  </Typography>
                )}
              </Grid> */}
            </div>


            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%', marginBottom: '16px' }}>
            <Box  sx={{ borderBottom: '1px solid #ccc', padding: '12px',display: {
                  md: 'flex',
                  xs: 'block'
                }, justifyContent: 'space-between', alignItems: 'center' }}> 
                <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600', marginBottom: {
                  md:'0',xs:'12px'
                } }}>6S Audit Analytics - Group Name(Out of 33),  Group Leader</Typography>
                 <Box display="flex" alignItems="center"  sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        alignItems: 'center', 
        marginTop: '8px',  // Moves the select boxes below Typography
        gap: '3px' 
      }}>
                  <Select
                    value={selectedYearFirstgraph}
                    onChange={handleYearChangeFirstgraph}
                    size="small"
                    sx={{
                      height: "32px",
                      fontSize: "14px",
                      padding: "4px 0px",
                      minWidth: "70px",
                      width: "auto",
                      flexShrink: 0, // Prevents shrinking
                    }}
                  >
                    {years.map(year => (
                      <MenuItem key={year} value={year}>{year}</MenuItem>
                    ))}
                  </Select>

                  <Select
                    value={selectedGroupFirstgraph || "all"}
                    onChange={handleGroupChangeFirstgraph}
                    displayEmpty
                    size="small"
                    sx={{
                      height: "32px",
                      fontSize: "14px",
                      padding: "4px 0px",
                      minWidth: "100px", // Set a fixed width
                      maxWidth: "120px", // Prevents expansion
                      width: "120px",
                      flexShrink: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <MenuItem value="all">All Groups</MenuItem>
                    {availableGroupsFirstGraph.map(group => (
                      <MenuItem key={group.group_id} value={group.group_id}>
                        {group.group_name}
                      </MenuItem>
                    ))}
                  </Select>

                  <Select
                    value={selectedZoneFirstgraph}
                    onChange={handleZoneChangeFirstgraph}
                    multiple
                    size="small"
                    sx={{
                      height: "32px",
                      fontSize: "14px",
                      padding: "4px 0px",
                      minWidth: "70px",
                      width: "auto",
                      flexShrink: 0, // Prevents shrinking
                    }}
                    displayEmpty
                  >
                    {selectedGroupFirstgraph === "all" && (
                      <MenuItem value="all">All Zones</MenuItem>
                    )}

                    {selectedGroupFirstgraph !== "all" && availableZonesFirstGraph.length > 0 && (
                      <>
                        <MenuItem value="selectAll">
                          <Checkbox
                            checked={selectAllZones}
                            onChange={handleSelectAllZones}
                          />
                          Select All Zones
                        </MenuItem>

                        {availableZonesFirstGraph.map(zone => (
                          <MenuItem key={zone.id} value={zone.id}>
                            <Checkbox
                              checked={selectedZoneFirstgraph.includes(zone.id) || selectAllZones}
                              onChange={() => handleZoneSelection(zone.id)}
                            />
                            {zone.name}
                          </MenuItem>
                        ))}
                      </>
                    )}
                  </Select>
                  <IconButton onClick={handleMenuOpenFirst}>
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={chartFirstAnchorEl}
                    open={openFirst}
                    onClose={handleMenuCloseFirstChart}
                  >
                    <MenuItem onClick={() => { downloadCSVFirstGraph(); handleMenuCloseFirstChart(); }}>Download as CSV</MenuItem>
                    <MenuItem onClick={() => { downloadPNGFirstGraph(); handleMenuCloseFirstChart(); }}>Download as PNG</MenuItem>
                    <MenuItem onClick={() => { downloadSVGFirstGraph(); handleMenuCloseFirstChart(); }}>Download as SVG</MenuItem>
                  </Menu>

                </Box>
              </Box>
              <Box id="first-graph-chart" sx={{ width: '100%', overflow: 'hidden', display: "flex", justifyContent: 'center' }}>
                <Bar data={generateChartDataFirstgraph()} options={chartOptionsFirstgraph} />
              </Box>
            </Box>
            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%', marginBottom: '16px' }}>
               <Box  sx={{ borderBottom: '1px solid #ccc', padding: '12px',display: {
                  md: 'flex',
                  xs: 'block'
                }, justifyContent: 'space-between', alignItems: 'center' }}> 
           

                <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>6S Audit Analytics  - Group Name (Group Comparison Chart)</Typography>
                {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}> */}
                <Box display="flex" alignItems="center"  sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        alignItems: 'center', 
        marginTop: '8px',  // Moves the select boxes below Typography
        gap: '8px' 
      }}>
                  <Select
                    value={selectedYear}
                    size="small"
                    sx={{
                      height: "32px",
                      fontSize: "14px",
                      padding: "4px 0px",
                      minWidth: "70px",
                      width: "auto",
                      flexShrink: 0,
                    }}
                    onChange={handleYearCoordChange}
                  >
                    {years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>

                  <Select
                    value={selectedGroup || "all"}
                    onChange={handleGroupChange}
                    size="small"
                    sx={{
                      height: "32px",
                      fontSize: "14px",
                      padding: "4px 0px",
                      minWidth: "100px", // Set a fixed width
                      maxWidth: "120px", // Prevents expansion
                      width: "120px",
                      flexShrink: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    displayEmpty
                  >
                    <MenuItem value="all">All Groups</MenuItem>{" "}
                    {availableGroups.map((group) => (
                      <MenuItem key={group.group_id} value={group.group_id}>
                        {group.group_name}
                      </MenuItem>
                    ))}
                  </Select>

                  <IconButton onClick={handleMenuOpen}>
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={chartanchorEl}
                    open={open}
                    onClose={handleMenuCloseChart}
                  >
                    <MenuItem onClick={() => { downloadCSVChart(); handleMenuClose(); }}>Download as CSV</MenuItem>
                    <MenuItem onClick={() => { downloadPNGChart(); handleMenuClose(); }}>Download as PNG</MenuItem>
                    <MenuItem onClick={() => { downloadSVGChart(); handleMenuClose(); }}>Download as SVG</MenuItem>
                  </Menu>
                </Box>
              </Box>
              <Box id="chart" sx={{ width: '100%', overflow: 'hidden', display: "flex", justifyContent: 'center' }}>
                <Bar data={generateChartData()} options={chartOptionscoord} />
              </Box>
            </Box>
            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%', marginBottom: '16px' }}>
              <Box id="first-graph-chart" sx={{ borderBottom: '1px solid #ccc', padding: '12px', display: {
                  md: 'flex',
                  xs: 'block'
                }, justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>6S Audit Analytics  - Group Name (Group Wise Chart)</Typography>
                <Box display="flex" alignItems="center"  sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        alignItems: 'center', 
        marginTop: '8px',  // Moves the select boxes below Typography
        gap: '2px' 
      }}>
                  <Select value={selectedYearSecondgraph} size="small" 
                   sx={{
                    height: "32px",
                    fontSize: "14px",
                    padding: "4px 0px",
                    minWidth: "70px",
                    width: "auto",
                    flexShrink: 0, // Prevents shrinking
                  }}

                  onChange={handleYearChangeSecondgraph}>
                    {years.map(year => (
                      <MenuItem key={year} value={year}>{year}</MenuItem>
                    ))}
                  </Select>

                  <Select
  value={selectedGroupSecondgraph}
  onChange={handleGroupChangeSecondgraph}
  size="small"
  multiple
  renderValue={(selected) =>
    selected
      .map((value) => {
        const group = availableGroupsSecondGraph.find((g) => g.group_id === value);
        return group ? group.group_name : value; // Show names, fallback to value if not found
      })
      .join(", ")
  }
  sx={{
    height: "32px",
    fontSize: "14px",
    padding: "4px 0px",
    minWidth: "75px", // Set a fixed width
    maxWidth: "100px", // Prevents expansion
    width: "100px",
    flexShrink: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }}
>
  <MenuItem value="all" sx={{ display: "flex", alignItems: "center" }}>
    <Checkbox checked={selectedGroupSecondgraph.includes("all")} />
    <ListItemText primary="All Groups" />
  </MenuItem>
  {availableGroupsSecondGraph.map((group) => (
    <MenuItem key={group.group_id} value={group.group_id}>
      <Checkbox checked={selectedGroupSecondgraph.includes(group.group_id)} />
      <ListItemText primary={group.group_name} />
    </MenuItem>
  ))}
</Select>


                  {/* prod code
                  <Select value={selectedGroupSecondgraph} onChange={handleGroupChangeSecondgraph} size="small"
                   sx={{
                    height: "32px",
                    fontSize: "14px",
                    padding: "4px 0px",
                    minWidth: "70px",
                    width: "auto",
                    flexShrink: 0, // Prevents shrinking
                  }}
                   multiple>
                    <MenuItem value="all" sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox checked={selectedGroupSecondgraph.includes("all")} />
                      <ListItemText primary="All Groups" />
                    </MenuItem>
                    {availableGroupsSecondGraph.map(group => (
                      <MenuItem key={group.group_id} value={group.group_id}>
                        <Checkbox checked={selectedGroupSecondgraph.includes(group.group_id)} />
                        <ListItemText primary={group.group_name} />
                      </MenuItem>
                    ))}
                  </Select> */}

                  <Select
                    value={selectedZoneSecondgraph}
                    onChange={handleZoneChangeSecondgraph}
                    multiple
                    size="small"
                    sx={{
                      height: "32px",
                      fontSize: "14px",
                      padding: "4px 0px",
                      minWidth: "75px", // Set a fixed width
                      maxWidth: "100px", // Prevents expansion
                      width: "100px",
                      flexShrink: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    renderValue={(selected) => {
                      const selectedZoneNames = selected.map(id => {
                        const zone = availableZonesSecondGraph.find(zone => zone.id === id);
                        return zone ? zone.name : null;
                      }).filter(name => name !== null);

                      return selectedZoneNames.join(", ");
                    }}
                  >
                    {selectedGroupSecondgraph.includes("all") && (
                      <MenuItem value="all">
                        <Checkbox checked={selectedZoneSecondgraph.includes("all")} />
                        <ListItemText primary="All Zones" />
                      </MenuItem>
                    )}
                    {availableZonesSecondGraph.map(zone => (
                      <MenuItem key={zone.id} value={zone.id}>
                        <Checkbox checked={selectedZoneSecondgraph.includes(zone.id)} />
                        <ListItemText primary={zone.name} />
                      </MenuItem>
                    ))}
                  </Select>


                  <IconButton onClick={handleMenuOpenSecond}>
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={chartSecondAnchorEl}
                    open={openSecond}
                    onClose={handleMenuCloseSecondChart}
                  >
                    <MenuItem onClick={() => { downloadCSVSecondGraph(); handleMenuCloseSecondChart(); }}>Download as CSV</MenuItem>
                    <MenuItem onClick={() => { downloadPNGSecondGraph(); handleMenuCloseSecondChart(); }}>Download as PNG</MenuItem>
                    <MenuItem onClick={() => { downloadSVGSecondGraph(); handleMenuCloseSecondChart(); }}>Download as SVG</MenuItem>
                  </Menu>
                </Box>
              </Box>
              <Box id="second-graph-chart" sx={{ width: '100%', overflow: 'hidden', display: "flex", justifyContent: 'center' }}>
                <Bar data={generateChartDataSecondgraph()} options={chartOptionsSecondgraph} />
              </Box>
              {/* <BarChartDashboard chartdata={totalScoresRadar}/> */}

            </Box>
            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%', marginBottom: '16px' }}>
              <Box id="first-graph-chart" sx={{ borderBottom: '1px solid #ccc', padding: '12px', display: {
                  md: 'flex',
                  xs: 'block'
                }, justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Audit Summary - All Group Positive & Negative Scores</Typography>
              </Box>
              <Box sx={{ width: '100%', overflow: 'auto' }}>
                {coordinatorChartData && coordinatorChartData.length ? (
                  renderCoordinatorTable()
                ) : (
                  <p>No data Available</p>
                )}
              </Box>
            </Box>

          </>
        ) : isGroupLeader ? (
          <>


            <Select
              value={selectedZoneId || ""}
              onChange={handleZoneChange}
              displayEmpty
              sx={{
                height: "32px",
                fontSize: "14px",
                padding: "4px 0px",
                minWidth: "100px", // Set a fixed width
                maxWidth: "120px", // Prevents expansion
                width: "120px",
                flexShrink: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              <MenuItem value="" disabled>
                Select Zone
              </MenuItem>
              {zones.map((zone) => (
                <MenuItem key={zone.id} value={zone.id}>
                  {zone.name}
                </MenuItem>
              ))}
            </Select>
            <Select
              value={selectedYear}
              onChange={handleYearChange}
              sx={{
                height: "32px",
                fontSize: "14px",
                padding: "4px 0px",
                minWidth: "75px",
                width: "auto",
                flexShrink: 0, // Prevents shrinking
              }}
            >
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
            {groupLeaderChartData && groupLeaderChartData.length ? (
              <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%', marginBottom: '16px', marginTop: '16px' }}>
                <Box id="first-graph-chart" sx={{ borderBottom: '1px solid #ccc', padding: '12px', display: {
                  md: 'flex',
                  xs: 'block'
                }, justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Group Leader Assessment Dashboard</Typography>
                  <Box
                    id="chartContainer"
                    display="flex" alignItems="center"  sx={{ 
                      display: 'flex', 
                      justifyContent: 'flex-end', 
                      alignItems: 'center', 
                      marginTop: '8px',  // Moves the select boxes below Typography
                      gap: '2px' 
                    }}
                  >
                    <IconButton
                      onClick={handleMenuClick}
                    >
                      <MoreVertIcon />
                    </IconButton>

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem
                        onClick={() => {
                          downloadCSV();
                          handleMenuClose();
                        }}
                      >
                        Download as CSV
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          downloadPNG();
                          handleMenuClose();
                        }}
                      >
                        Download as PNG
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          downloadSVG();
                          handleMenuClose();
                        }}
                      >
                        Download as SVG
                      </MenuItem>
                    </Menu>


                  </Box>
                </Box>
                <Box sx={{ width: '100%', overflow: 'hidden', padding: '16px' }}>
                  <Bar
                    data={getGroupLeaderChartData()}
                    options={chartOptions}
                    plugins={[ChartDataLabels]}
                    height={'400px!important'}
                  />
                </Box>
              </Box>
            ) : (
              <p>No Data Available</p>
            )}
            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%', marginBottom: '16px' }}>
              <Box id="first-graph-chart" sx={{ borderBottom: '1px solid #ccc', padding: '12px', display: {
                  md: 'flex',
                  xs: 'block'
                }, justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Audit Summary - All Group Positive & Negative Scores</Typography>
              </Box>
              <Box sx={{ width: '100%', overflow: 'hidden' }}>
                {groupLeaderChartData && groupLeaderChartData.length ? (
                  renderGroupLeaderTable()
                ) : (
                  <p>No Data Available</p>
                )}
              </Box>
            </Box>

          </>
        ) : canAccessDashboard ? (
          <>
            <Box sx={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Audit Summary - {isCoordinator ? ' WCM Co-ordinator - Plant Name' : `${zoneInfo}`}</Typography>
              <Select
                value={selectedYear}
                size="small"
                onChange={handleYearChange}
                sx={{
                  height: "32px",
                  fontSize: "14px",
                  padding: "4px 0px",
                  minWidth: "75px",
                  width: "auto",
                  flexShrink: 0, // Prevents shrinking
                }}
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Grid container sx={{ padding: '0' }}>
             <Grid item md={3} sm={6} xs={12}>
                <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', padding: '12px', margin: '8px' }}>
                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontSize: '14px', color: '#616161' }}>Total Audits</Typography>
                              <DocumentIcon />
                     </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    {/* <Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'left', margin: '12px 0' }}>{isCoordinator && {}}{!isCoordinator && {totalAuditscardgrp}}</Typography> */}
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '34px',
                        width: '100%',
                        fontWeight: 'bold',
                        textAlign: 'left',
                        margin: '12px 0'
                      }}
                    >
                      {getTotalAudits()}
                    </Typography>
                    <LineArea width={100} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                      {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                    </Typography>
                  </Box>
                </Box>

              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', padding: '12px', margin: '8px' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: '14px', color: '#616161' }}>Completed Audits</Typography>
                    <DocumentIcon />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    {/* <Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'left', margin: '12px 0' }}>{isCoordinator && {}}{!isCoordinator && {completedAuditcardgrp}}</Typography> */}
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '34px',
                        width: '100%',
                        fontWeight: 'bold',
                        textAlign: 'left',
                        margin: '12px 0'
                      }}
                    >
                      {getCompletedAuditsCount()}
                    </Typography>
                    <LineArea width={100} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                      {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                    </Typography>
                  </Box>
                </Box>

              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', padding: '12px', margin: '8px' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: '14px', color: '#616161' }}>Pending Audits</Typography>
                    <DocumentIcon />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '34px',
                        width: '100%',
                        fontWeight: 'bold',
                        textAlign: 'left',
                        margin: '12px 0'
                      }}
                    >
                      {getPendingAuditsCount()}
                    </Typography>
                    <LineArea width={100} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                      {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                    </Typography>
                  </Box>
                </Box>

              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', padding: '12px', margin: '8px' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: '14px', color: '#616161' }}>Total Score (YTD)</Typography>
                    <DocumentIcon />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '34px',
                        width: '100%',
                        fontWeight: 'bold',
                        textAlign: 'left',
                        margin: '12px 0'
                      }}
                    >
                      {getAveragePositiveScores()}
                    </Typography>
                    <LineArea width={100} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                      {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                    </Typography>
                  </Box>
                </Box>

              </Grid>
            </Grid>
            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%', marginBottom: '16px', marginTop: '16px' }}>
              <Box id="chart-container" sx={{ borderBottom: '1px solid #ccc', padding: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>6S Audit Analytics</Typography>
                <Box
                  id="chartContainer"
                  sx={{ position: "relative" }}
                >
                  <IconButton
                    onClick={handleMenuZoneClick}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={zoneanchorEl}
                    open={Boolean(zoneanchorEl)}
                    onClose={handleMenuZoneClose}
                  >
                    <MenuItem onClick={downloadAsCSV}>
                      Download as CSV
                    </MenuItem>
                    <MenuItem onClick={downloadAsPNG}>
                      Download as PNG
                    </MenuItem>
                    <MenuItem onClick={downloadAsSVG}>
                      Download as SVG
                    </MenuItem>
                  </Menu>
                </Box>
              </Box>
              <Box sx={{ padding: '16px' }}>
                <Bar
                  data={getChartData()}
                  options={zoneleaderChartOptions}
                  height={'400px!important'}
                />
              </Box>
            </Box>


            <Box>
              {chartData && chartData.length > 0 ? (
                <>
  <TableContainer component={Paper} sx={{ marginTop: "16px" }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>S.No</TableCell>
                          <TableCell>Months</TableCell>
                          <TableCell>Zone Name</TableCell>
                          <TableCell>Zone Code</TableCell>
                          <TableCell>Auditor</TableCell>
                          <TableCell>Audited On</TableCell>
                          <TableCell>Positive Scores</TableCell>
                          <TableCell>Negative Scores</TableCell>
                          <TableCell>Score status</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {chartData.map((item, index) => {
                          const { positiveScores, negativeScores } =
                            calculateScores(item.details);
                          const formattedDate = new Date(
                            item.audit_date
                          ).toLocaleDateString();
                          return (
                            <TableRow key={item.assessment_id}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{item.month_name}</TableCell>
                              <TableCell>{item.zone_name}</TableCell>
                              <TableCell>{item.zone_code}</TableCell>
                              <TableCell>{item.auditor_name}</TableCell>
                              <TableCell>{formattedDate}</TableCell>
                              <TableCell>
                                {positiveScores}
                                {positiveScores >= 31 && (
                                  <FontAwesomeIcon
                                    icon={faArrowCircleUp}
                                    style={{
                                      color: "green",
                                      marginLeft: "8px",
                                    }}
                                  />
                                )}
                              </TableCell>

                              <TableCell>
                                {negativeScores}
                                {positiveScores < 31 && (
                                  <FontAwesomeIcon
                                    icon={faArrowCircleDown}
                                    style={{ color: "red", marginLeft: "8px" }}
                                  />
                                )}
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    backgroundColor:
                                      positiveScores >= 31
                                        ? "#34C7591A"
                                        : "#E4003A1A",
                                    color:
                                      positiveScores >= 31
                                        ? "#34C759"
                                        : "#E4003A",
                                  }}
                                >
                                  {positiveScores >= 31 ? (
                                    <>
                                      High Score
                                      <FontAwesomeIcon
                                        icon={faArrowCircleUp}
                                        style={{
                                          color: "#34C759",
                                          marginRight: "4px",
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      Low Score
                                      <FontAwesomeIcon
                                        icon={faArrowCircleDown}
                                        style={{
                                          color: "#E4003A",
                                          marginRight: "4px",
                                        }}
                                      />
                                    </>
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={() =>
                                    handleDownloadRowZonetable(
                                      item.zone_id,
                                      item.audit_date
                                    )
                                  }
                                >
                                  <GetAppIcon />
                                </IconButton>
                              </TableCell>

                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <p>Loading chart data...</p>
              )}
            </Box>
          </>
        ) : (
          <p>You do not have access to view this data.</p>
        )}
      </Box>
    </Box>
  );


};

export default Dashboard;
